<app-priority-top-banner [productsQualifyResponse]="productsQualifyResponse" [pageName]="pageName"></app-priority-top-banner>

<div class="filter_btn_section">
  <button id="btn_userJourney_filter_toAll_offersPage" name="btn_userJourney_filter_toAll_offersPage"
    (click)="FilterProducts('all')" class="filter_btn" [ngClass]="{'active': ShowAll}">All</button>
  <button id="btn_userJourney_filter_toDebtSolutions_offersPage"
    name="btn_userJourney_filter_toDebtSolutions_offersPage" *ngIf="!IsUnderDC" (click)="FilterProducts('dc')"
    class="filter_btn" [ngClass]="{'active': selectedFilters.includes('dc') && !ShowAll}">Debt solutions</button>
  <button id="btn_userJourney_filter_toInsurances_offersPage" *ngIf="ShowInsurancesFilter"
    name="btn_userJourney_filter_toInsurances_offersPage" class="filter_btn" (click)="FilterProducts('insurances')"
    [ngClass]="{'active': selectedFilters.includes('insurances') && !ShowAll}">Insurances</button>
  <button id="btn_userJourney_filter_toPersonalLoans_offersPage"
    name="btn_userJourney_filter_toPersonalLoans_offersPage" (click)="FilterProducts('money')"
    [ngClass]="{'active': selectedFilters.includes('money') && !ShowAll}" class="filter_btn">Personal loans</button>
  <button id="btn_userJourney_filter_toRetailAndCredit_offersPage"
    name="btn_userJourney_filter_toRetailAndCredit_offersPage" class="filter_btn"
    (click)="FilterProducts('retailCredit')"
    [ngClass]="{'active': selectedFilters.includes('retailCredit') && !ShowAll}">Retail & credit</button>
  <button id="btn_userJourney_filter_toVehicleFinance_offersPage"
    name="btn_userJourney_filter_toVehicleFinance_offersPage" class="filter_btn" (click)="FilterProducts('car')"
    [ngClass]="{'active': selectedFilters.includes('car')&& !ShowAll}">Vehicle finance</button>
  <button id="btn_userJourney_filter_toHomeLoans_offersPage" name="btn_userJourney_filter_toHomeLoans_offersPage"
    class="filter_btn" (click)="FilterProducts('home')"
    [ngClass]="{'active': selectedFilters.includes('home')&& !ShowAll}">Home loans</button>
</div>



<div class="prducts-ui-update b5containeradjust pt-md-4">
  <div class="container">

    <div *ngIf="jmLegalInsDisabled && !showStdLegalInsAlert"
      class="alert alert-stdlegal d-flex align-items-center p-2 mt-3 me-3 ms-3 me-md-0 ms-md-0 mt-md-0" role="alert">
      <div class="me-2" h-100>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15h-2v-2h2v2zm0-4h-2V5h2v6z"
            fill="white" />
        </svg>
      </div>
      <div class="me-2">
        <h3 class="alert-stdlegal-title mb-0">An insurance application is already in progress.</h3>
        <div class="alert-stdlegal-desc mb-0"> Please try again after 15 mins.</div>
      </div>

      <button (click)="closeJmLegalDisableAlert()">
        <span aria-hidden="true" id="btn_auxElement_legalInsurance_closeAlertModal_solutions"
          name="btn_auxElement_legalInsurance_closeAlertModal_solutions">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M2.14645 2.75668C1.95118 2.56806 1.95118 2.26223 2.14645 2.0736C2.34171 1.88497 2.65829 1.88497 2.85355 2.0736L8 7.0452L13.1464 2.0736C13.3417 1.88497 13.6583 1.88497 13.8536 2.0736C14.0488 2.26223 14.0488 2.56806 13.8536 2.75668L8.70711 7.72829L13.8536 12.6999C14.0488 12.8885 14.0488 13.1943 13.8536 13.383C13.6583 13.5716 13.3417 13.5716 13.1464 13.383L8 8.41137L2.85355 13.383C2.65829 13.5716 2.34171 13.5716 2.14645 13.383C1.95119 13.1943 1.95119 12.8885 2.14645 12.6999L7.29289 7.72829L2.14645 2.75668Z"
              fill="white" />
          </svg>
        </span>
      </button>
    </div>

    <div #stdAlert *ngIf="showStdLegalInsAlert"
      class="alert alert-stdlegal d-flex align-items-center p-2 mt-3 me-3 ms-3 me-md-0 ms-md-0 mt-md-0" role="alert">
      <div class="me-2 h-100" [innerHTML]="stdLegalInsStateSVG"></div>

      <div class='me-2'>
        <h3 class="alert-stdlegal-title mb-0">Legal Cover Application</h3>
        <div class="alert-stdlegal-desc mb-0" [innerHTML]="stdLegalAlertResponse?.stateBody" class="mb-0"></div>
      </div>

      <button (click)="closeAlert()">
        <span aria-hidden="true" id="btn_auxElement_legalInsurance_closeInfoModal_solutions"
          name="btn_auxElement_legalInsurance_closeInfoModal_solutions">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M2.14645 2.75668C1.95118 2.56806 1.95118 2.26223 2.14645 2.0736C2.34171 1.88497 2.65829 1.88497 2.85355 2.0736L8 7.0452L13.1464 2.0736C13.3417 1.88497 13.6583 1.88497 13.8536 2.0736C14.0488 2.26223 14.0488 2.56806 13.8536 2.75668L8.70711 7.72829L13.8536 12.6999C14.0488 12.8885 14.0488 13.1943 13.8536 13.383C13.6583 13.5716 13.3417 13.5716 13.1464 13.383L8 8.41137L2.85355 13.383C2.65829 13.5716 2.34171 13.5716 2.14645 13.383C1.95119 13.1943 1.95119 12.8885 2.14645 12.6999L7.29289 7.72829L2.14645 2.75668Z"
              fill="white" />
          </svg>
        </span>
      </button>

    </div>

    <div class="px-md-0 px-3">
      <div ngbAccordion #acc="ngbAccordion">
        <div ngbAccordionItem [collapsed]="false" id="panel-1" *ngIf="(!IsUnderDC) &&(ShowControlDebt||ShowAll)">
          <div ngbAccordionHeader>
            <button ngbAccordionButton><span>Debt solutions</span></button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="d-flex flex-wrap align-items-stretch pt-3 w-100">
                  <div class="col-md-6 px-3 mb-3 d-flex align-items-stretch" id="DcQuote">
                    <div class=" d-flex flex-wrap align-items-center justify-content-between p-3 bgimg bg-white">
                      <div class="imgsec">
                        <img src="../../assets/images/dblogonew.png" alt="" />
                      </div>
                      <div class="productcont">
                        <div class="toppanl">
                          <h3 class="product-caption">DebtBusters Debt Consolidation</h3>
                          <span class="product-status" [ngClass]="dcStatus?.qualifyClass"
                            [innerHTML]="dcStatus?.description"></span>
                          <p class="product-text">Get instant relief by improving your cashflow. Combine your debts into
                            a single, affordable, monthly payment, and receive immediate legal protection.</p>

                        </div>
                        <div
                          [ngClass]="(dcStatus?.criteria == 'no-yes')?'buttonpanel dcStaton flex-wrap':'buttonpanel'">
                          <div class="col-lg-8 col-md-12 col-7 ps-0 me-auto font-style"
                            *ngIf="dcStatus?.criteria == 'no-yes'">
                            Estimated monthly reduction in credit payments: <span
                              class="text-green text-bold font-stylevalue">R {{(monthlyInstalment - dbc_Dcrs) |
                              number}}</span>
                          </div>
                        
                          <button class="bank_button mb-0" *ngIf="dcStatus?.criteria != 'no-yes'"
                            (click)="debtConsolidationCallback()" id="btn_leadGen_consolidateLoan_callBack_solutionTileSolutionsPage"
                            name="btn_leadGen_consolidateLoan_callBack_solutionTileSolutionsPage">{{dcStatus?.ctaText}}</button>

                          <button class="bank_button mb-0"
                            *ngIf="dcStatus?.criteria == 'no-yes' && this.UserGeminiNumber <= 400"
                            (click)="OmniLeadCreate('btn_leadGen_consolidateLoan_dcCallback_solutions','Callback')"
                            id="btn_leadGen_consolidateLoan_dcCallback_solutions"
                            name="btn_leadGen_consolidateLoan_dcCallback_solutions">{{dcStatus?.ctaText}}</button>

                          <button class="bank_button mb-0"
                            *ngIf="dcStatus?.criteria == 'no-yes' && this.UserGeminiNumber > 400 && this.UserGeminiNumber <= 999"
                            (click)="OmniLeadCreate('btn_leadGen_consolidateLoan_dcOnlineJourney_solutions','Online')"
                            id="btn_leadGen_consolidateLoan_dcOnlineJourney_solutions"
                            name="btn_leadGen_consolidateLoan_dcOnlineJourney_solutions">{{dcStatus?.ctaText}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

      </div>


      <div #getMoneySection id="getMoneySection">

        <div ngbAccordion #acc="ngbAccordion">
          <div ngbAccordionItem id="panel-3" [collapsed]="false" *ngIf="ShowInsurances">
            <div ngbAccordionHeader>
              <button ngbAccordionButton><span>Insurances</span></button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template ngbPanelContent>
                  <div class="d-flex flex-wrap align-items-stretch pt-3 w-100">
                    <div class="col-md-6 mb-3 px-3 d-flex align-items-stretch" id="VehicleFinance">
                      <div
                        class="w-100 d-flex flex-wrap align-items-stretch justify-content-between p-3 bgimg bg-white">
                        <div class="imgsec">
                          <img src="../../assets/images/logoJM.png" width="110px" alt="" />
                        </div>
                        <div class="productcont">
                          <div class="toppanl">
                            <h3 class="product-caption">
                              JustMoney Legal Cover</h3>
                            <span [ngClass]="jmLegalInsStatus?.qualifyClass">
                              <svg *ngIf="jmLegalInsStatus?.qualifyClass == 'done-status'"
                                xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none" class="me-1">
                                <path
                                  d="M8 14.4904C4.13401 14.4904 1 11.4629 1 7.72821C1 3.99356 4.13401 0.966027 8 0.966027C11.866 0.966027 15 3.99356 15 7.72821C15 11.4629 11.866 14.4904 8 14.4904ZM8 15.4564C12.4183 15.4564 16 11.9964 16 7.72821C16 3.46004 12.4183 0 8 0C3.58172 0 0 3.46004 0 7.72821C0 11.9964 3.58172 15.4564 8 15.4564Z"
                                  fill="white"></path>
                                <path
                                  d="M10.9697 4.80083C10.9626 4.80767 10.9559 4.8149 10.9498 4.82251L7.4774 9.09682L5.38388 7.07443C5.09098 6.79149 4.61611 6.79149 4.32322 7.07443C4.03032 7.35737 4.03032 7.81611 4.32322 8.09905L6.96966 10.6556C7.26256 10.9385 7.73743 10.9385 8.03032 10.6556C8.03685 10.6493 8.043 10.6426 8.04876 10.6357L12.041 5.81497C12.3232 5.53129 12.3196 5.08031 12.0303 4.80083C11.7374 4.51789 11.2626 4.51789 10.9697 4.80083Z"
                                  fill="white"></path>
                              </svg> {{jmLegalInsStatus?.description}}</span>
                            <p class="product-text">Life happens. Get affordable legal protection with JustMoney Legal
                              Cover – expert help for credit, vehicle, and contract disputes from just R100 a month.</p>
                          </div>
                          <div class="buttonpanel">
                            <button
                              *ngIf="jmLegalInsStatus?.isQualify && jmLegalInsStatus?.qualifyClass != 'done-status'"
                              [disabled]="jmLegalInsStatus?.qualifyClass === 'low-status'"
                              [ngClass]="jmLegalInsStatus?.qualifyClass == 'low-status' ? 'btn-disabled' : ''"
                              class="bank_button mb-0 ms-0" (click)="CreateSapiVisit()"
                              name="btn_journey_legalInsurance_initiateJourney_solutions"
                              id="btn_journey_legalInsurance_initiateJourney_solutions">Get offer</button>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <div ngbAccordion #acc="ngbAccordion">
          <div ngbAccordionItem [collapsed]="false" id="panel-2" *ngIf="ShowGetMoney ||ShowAll">
            <div ngbAccordionHeader>
              <button ngbAccordionButton><span>Personal loans</span></button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <div class="d-flex flex-wrap align-items-stretch pt-3 w-100">
                    <div class="col-md-6 px-3 mb-3 d-flex align-items-stretch" id="SPL">
                      <div
                        class=" d-flex flex-wrap align-items-start justify-content-between p-3 bgimg bg-white  w-100">
                        <div class="imgsec">
                          <img src="../../assets/images/sanlam.png" alt="" />
                        </div>
                        <div class="productcont">
                          <div class="toppanl">
                            <h3 class="product-caption">Sanlam Personal Loan</h3>
                            <div *ngIf="isSplContractPending==false; else noPLData">
                              <div class="d-flex align-items-center">
                              <span class="product-status" [ngClass]="splStatus?.qualifyClass"
                                [innerHTML]="splStatus?.description"></span> 
                              <!-- Guidemark -->
                                <!-- <div *ngIf="dcEligibility" class="info-wrapper ms-2 mb-1">
                                  @if (UserGeminiNumber >= 600 && UserGeminiNumber
                                  <= 799) { 
                                    <img src="../../assets/svgs/info.svg" alt="info-svg" />
                                  } 
                                   @if (UserGeminiNumber >= 800 && UserGeminiNumber
                                  <= 999) { 
                                    <img src="../../assets/svgs/warning-icon.svg" alt="warning-svg" />
                                  }
                                  <div class="custom-tooltip mt-2">
                                    <h4 class="fw-bold gray-color">Make an informed choice</h4>
                                    <hr class="custom-hr" />
                                    <p class="tooltip-text">
                                      Taking a new loan can increase your debt load. If you're already juggling payments, consider
                                      <a class="tooltip-click-text text-decoration-underline" (click)="openOffcanvasguidemark('Sanlam','solutions')">DebtBusters’ Debt Consolidation</a> offer.
                                    </p>
                                  </div>
                                </div>
                                -->
                                </div>
                                 <!-- Guidemark -->
                              
                              <p class="product-text">Realise your dreams or pay for emergencies with a cash boost of up
                                to
                                R350,000. Personalised interest rates, affordable installments, and up to 84 months’
                                repayment term.</p>
                            </div>
                            <ng-template #noPLData>
                              <p class="noscsPL pt-3">Your Sanlam personal loan application is in progress</p>
                            </ng-template>
                          </div>
                          <div class="buttonpanel" *ngIf="isSplContractPending==false">

                            <button class="bank_button mb-0" id="btn_SPLCallMe_ProductPage"
                              name="btn_SPLCallMe_ProductPage" (click)="splCallbackApplyNow()"
                              *ngIf="splStatus?.criteria?.toLowerCase() != 'approve' && splStatus?.criteria?.toLowerCase() != 'maybe-high'">{{splStatus?.ctaText}}</button>

                            <button class="bank_button mb-0" id="btn_SPLViewOffer_ProductPage"
                              name="btn_SPLViewOffer_ProductPage" (click)="personalLoanOffer()"
                              *ngIf="splStatus?.criteria?.toLowerCase() == 'approve' || splStatus?.criteria?.toLowerCase() == 'maybe-high'">{{splStatus?.ctaText}}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 px-3 mb-3 d-flex align-items-stretch"
                      *ngIf="this.ssfStatus?.criteria === '750-10000'" id="Ssf">
                      <div
                        class=" d-flex flex-wrap flex-md-nowrap align-items-start justify-content-between p-3 bgimg bg-white w-100">
                        <div class="ssfimgcont text-center ">
                          <div class="ssfdarkbg">

                            <img src="../../assets/images/ssflogo.png" alt="" />
                          </div>
                        </div>
                        <div class="productcont">
                          <div class="toppanl">
                            <h3 class="product-caption">Smartsolve Finance Personal Loan</h3>

                            <span class="product-status mb-2" [ngClass]="ssfStatus?.qualifyClass"
                              [innerHTML]="ssfStatus?.description"></span>

                            <p class="product-text">Bridge the gap with hassle-free credit. Enjoy R3,000 to R6,000 at a
                              low 5% fixed interest rate, no forced insurance or hidden fees, and up to six months'
                              repayment terms.</p>
                          </div>

                          <div class="buttonpanel mt-auto">
                            <a class="bank_button mb-0" name="btn_leadGen_offerTileSsf_redirect_solutions"
                              id="btn_leadGen_offerTileSsf_redirect_solutions" [href]="ssfApplyRedirectUrl"
                              target="_blank" (click)="DismissNudge()">{{ssfStatus?.ctaText}}</a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6  px-3 mb-3 d-flex align-items-stretch" *ngIf="IsShowCapfin"
                      id="{{CapfinProductTileId}}">
                      <div class=" d-flex flex-wrap align-items-center justify-content-between p-3 bgimg bg-white">
                        <div class="imgsec">
                          <img src="../../assets/images/capfinlogo.png" alt="" />
                        </div>
                        <div class="productcont">
                          <div class="toppanl">
                            <h3 class="product-caption">Capfin Personal Loan</h3>
                            <div class="d-flex align-items-center">
                            <span class="product-status" [ngClass]="capfinStatus?.qualifyClass"
                              [innerHTML]="capfinStatus?.description"></span>
                              <!-- Guidemark -->
                                <!-- <div class="info-wrapper ms-2 mb-1" *ngIf="dcEligibility">
                                  @if (UserGeminiNumber >= 600 && UserGeminiNumber
                                  <= 799) { 
                                    <img src="../../assets/svgs/info.svg" alt="info-svg" />
                                   } 
                                  @if (UserGeminiNumber >= 800 && UserGeminiNumber
                                  <= 999) { 
                                    <img src="../../assets/svgs/warning-icon.svg" alt="warning-svg" />
                                  } 
                                  <div class="custom-tooltip mt-2">
                                    <h4 class="fw-bold gray-color">Make an informed choice</h4>
                                    <hr class="custom-hr" />
                                    <p class="tooltip-text">
                                      Taking a new loan can increase your debt load. If you're already juggling payments, consider
                                      <a class="tooltip-click-text text-decoration-underline" (click)="openOffcanvasguidemark('Capfin','solutions')">DebtBusters’ Debt Consolidation</a> offer.
                                    </p>
                                  </div>
                                </div>
                                -->
                                </div>
                                <!-- Guidemark -->
                            <p class="product-text">With Capfin, you can get an affordable and easy-to-manage loan of up
                              to R50 000. Enjoy a quick and easy application process, access to your loan account 24/7,
                              and no hidden costs.</p>

                          </div>
                          <div class="buttonpanel">
                            <a class="bank_button mb-0"
                              href="https://www.capfin.co.za/apply-now/application-details?a=CF000126" target="_blank"
                              name="{{capfinBtnName}}" id="{{capfinBtnName}}"
                              (click)="DismissNudge()">{{capfinStatus?.ctaText}}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>



        <div #creditCardsSection id="creditCardsSection">
          <div ngbAccordion #acc="ngbAccordion">
            <div ngbAccordionItem [collapsed]="false" *ngIf="ShowRetailAndCredit ||ShowAll">
              <div ngbAccordionHeader>
                <button ngbAccordionButton><span>Retail & credit</span></button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <div class="d-flex flex-wrap align-items-stretch pt-3 w-100">
                    <div class="col-md-6  px-3 mb-3 d-flex align-items-stretch">
                      <div class=" d-flex flex-wrap align-items-center justify-content-between p-3 bgimg bg-white">
                        <div class="imgsec">
                          <img src="../../assets/images/Mobicred digital credit Blue Logo.png" alt="" />
                        </div>
                        <div class="productcont">
                          <div class="toppanl">
                            <h3 class="product-caption">Mobicred Online Shopping Credit</h3>
                            <span class="product-status" [ngClass]="mobicredStatus?.qualifyClass"
                              [innerHTML]="mobicredStatus?.description"></span>
                            <p class="product-text">Apply easily for a digital credit facility of up to R50,000 and get
                              access to shop over 100K of your favorite brands, online or at selected in-store
                              retailers.</p>

                          </div>
                          <div class="buttonpanel">
                            <a class="bank_button mb-0" id="{{mobicredBtnName}}" name="{{mobicredBtnName}}"
                              href="https://url.za.m.mimecastprotect.com/s/sTbfCRgX94TgOzrgi9N1DH" target="_blank"
                              (click)="DismissNudge()">{{mobicredStatus?.ctaText}}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6  px-3 mb-3 d-flex align-items-stretch" id="Identity">
                      <div class=" d-flex flex-wrap align-items-center justify-content-between p-3 bgimg bg-white">
                        <div class="imgsec">
                          <img src="../../assets/images/identity.png" alt="" />
                        </div>
                        <div class="productcont">
                          <div class="toppanl">
                            <h3 class="product-caption">Identity Store Account</h3>
                            <span class="product-status" [ngClass]="identityStatus?.qualifyClass"
                              [innerHTML]="identityStatus?.description"></span>
                            <p class="product-text">Open an account to access credit, and benefit from exclusive offers,
                              promotions, competitions, and discounts.</p>

                          </div>
                          <div class="buttonpanel">
                            <p *ngIf="identityStatus?.ctaText=='Get offer' || identityStatus?.ctaText=='Call me'"
                              class="d-none"></p>
                            <a class="bank_button mb-0 cursor-pointer" *ngIf="identityStatus?.ctaText=='Call me' "
                              name="btn_leadGen_retailOfferIdentity_callBack_solutions"
                              id="btn_leadGen_retailOfferIdentity_callBack_solutions"
                              (click)="userCallback(50)">{{identityStatus?.ctaText}}</a>
                            <a class="bank_button mb-0" *ngIf="identityStatus?.ctaText=='Get offer'"
                              name="btn_leadGen_retailOfferIdentity_getOffer_solutions"
                              id="btn_leadGen_retailOfferIdentity_getOffer_solutions" href="{{identityProductRedirect}}"
                              target="_blank" (click)="DismissNudge()">{{identityStatus?.ctaText}}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6  px-3 mb-3 d-flex align-items-stretch" id="Truworths">
                      <div class=" d-flex flex-wrap align-items-center justify-content-between p-3 bgimg bg-white">
                        <div class="imgsec">
                          <img src="../../assets/images/truworths.png" alt="" />
                        </div>
                        <div class="productcont">
                          <div class="toppanl">
                            <h3 class="product-caption">Truworths Store Account</h3>
                            <span class="product-status" [ngClass]="truworthsStatus?.qualifyClass"
                              [innerHTML]='truworthsStatus?.description'></span>
                            <p class="product-text">Buy what you need and pay later. Benefit from an interest-free
                              option, and enjoy competitions, rewards, promotions, and discounts.</p>

                          </div>
                          <div class="buttonpanel">
                            <p *ngIf="truworthsStatus?.ctaText=='Get offer' || truworthsStatus?.ctaText=='Call me'"
                              class="d-none"></p>
                            <a class="bank_button mb-0 cursor-pointer" *ngIf="truworthsStatus?.ctaText=='Call me'"
                              name="btn_leadGen_retailOfferTruworths_callBack_solutions"
                              id="btn_leadGen_retailOfferTruworths_callBack_solutions"
                              (click)="userCallback(49)">{{truworthsStatus?.ctaText}}</a>
                            <a class="bank_button mb-0" *ngIf="truworthsStatus?.ctaText=='Get offer'"
                              name="btn_leadGen_retailOfferTruworths_getOffer_solutions"
                              id="btn_leadGen_retailOfferTruworths_getOffer_solutions" href="{{truworthsRedirect}}"
                              target="_blank" (click)="DismissNudge()">{{truworthsStatus?.ctaText}}</a>

                          </div>
                        </div>
                      </div>
                    </div>


                    <!-- <div class="col-md-6  px-3 mb-3 d-flex align-items-stretch" id="Nedbank">
                      <div class=" d-flex flex-wrap align-items-center justify-content-between p-3 bgimg bg-white">
                        <div class="imgsec imgnedbank">
                          <img src="../../assets/images/nedbank.png" alt="" />
                        </div>
                        <div class="productcont">
                          <div class="toppanl">
                            <h3 class="product-caption">Nedbank Credit Cards</h3>
                            <span class="product-status" [ngClass]="mobicredStatus?.qualifyClass"
                              [innerHTML]="mobicredStatus?.description"></span>
                            <p class="product-text">Get up to 55 days interest-free on your purchases, and pay low
                              monthly fees. Enjoy rewards, insurance, and travel benefits, depending on the product of
                              your choice. No hidden costs! </p>

                          </div>
                          <div class="buttonpanel">
                            
                            <a class="bank_button mb-0" id="{{nedbankBtnName}}" name="{{nedbankBtnName}}"
                              href="https://personal.nedbank.co.za/bank/credit-cards.html?cmpid=dis:dat:ret:data_discovery:2:ned"
                              target="_blank" (click)="DismissNudge()">{{mobicredStatus?.ctaText}}</a>
                          </div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ngbAccordion #acc="ngbAccordion">
          <div ngbAccordionItem [collapsed]="false" id="panel-4" *ngIf="ShowFinanceYourCar ||ShowAll">
            <div ngbAccordionHeader>
              <button ngbAccordionButton><span>Vehicle Finance</span></button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <div class="d-flex flex-wrap align-items-stretch pt-3 w-100">
                    <div class="col-md-6 mb-3 px-3 d-flex align-items-stretch" id="VehicleFinance">
                      <div
                        class="w-100 d-flex flex-wrap align-items-stretch justify-content-between p-3 bgimg bg-white">
                        <div class="imgsec">
                          <img src="../../assets/images/wingfield.png" alt="" />
                        </div>
                        <div class="productcont">
                          <div class="toppanl">
                            <h3 class="product-caption">Vehicle Finance</h3>
                            <span class="product-status" [ngClass]="vehicleFinanceStatus?.qualifyClass"
                              [innerHTML]="vehicleFinanceStatus?.description"></span>
                            <p class="product-text">Keen to buy a car? Secure your dream vehicle with a finance option
                              that’s tailored to your budget.</p>
                          </div>
                          <div class="buttonpanel">
                            <button class="bank_button btn-black mb-0" id="btnVFCalculator_ProductPage"
                              name=" btnVFCalculator_ProductPage" (click)="motorvehicleCal()">Calculator</button>
                            <button class="bank_button mb-0 ms-0" id="{{vehicleFinanceBtnName}}"
                              name="{{vehicleFinanceBtnName}}"
                              (click)="userCallback(vehicleFinanceCampaignSource)">{{vehicleFinanceStatus?.ctaText}}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <div ngbAccordion #acc="ngbAccordion">
          <div ngbAccordionItem [collapsed]="false" id="panel-6" *ngIf="ShowOwnAHome ||ShowAll">
            <div ngbAccordionHeader>
              <button ngbAccordionButton><span>Home loans</span></button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <div class="d-flex flex-wrap align-items-stretch pt-3 w-100">
                  <div class="col-md-6 mb-3 d-flex align-items-stretch px-3" id="Ooba">
                    <div class="w-100 d-flex flex-wrap align-items-stretch justify-content-between p-3 bgimg bg-white">
                      <div class="imgsec text-center">
                        <img src="../../assets/images/oobalogo.png" alt="" />
                      </div>
                      <div class="productcont">
                        <div class="toppanl">
                          <h3 class="product-caption">ooba Home Loans</h3>
                          <span class="product-status" [ngClass]="oobaStatus?.qualifyClass"
                            [innerHTML]="oobaStatus?.description"></span>
                          <p class="product-text">Get multiple quotes from all leading banks in 5 easy steps. Choose
                            the best offer, and ooba negotiates the rate and terms on your behalf, free of charge.
                            ooba ranks #1 in home loans.</p>
                        </div>
                        <div [hidden]="totalLoanAmount != null && totalMonthlyRepaymentAmount != null">
                          <div class="px-0 py-3 w-100 rounded">
                            <div class="d-flex flex-wrap justify-content-end">
                              <button class="bank_button btn-black mb-0 ms-0 mr-2" id="btn_OobaCalculatorPopUp_Products"
                                name="btn_OobaCalculatorPopUp_Products" (click)="calculatorPopUP()">Calculator</button>
                              <button class="bank_button mb-0 ms-0 me-0" (click)="generateOobaLeads(false,true,false)"
                                id="{{oobaBtnName}}" name="{{oobaBtnName}}">{{buttonText ? buttonText : 'Call
                                Me'}}</button>
                            </div>
                          </div>
                        </div>
                        <div [hidden]="totalLoanAmount == null || totalMonthlyRepaymentAmount == null">
                          <div class="light-bg-gry px-0 py-3 w-100 rounded">
                            <div class="d-flex flex-wrap w-100 mb-3">
                              <div class="col-md-12 col-lg-7 col-6 m-0 ps-3 ps-lg-3 ps-md-2">
                                <p class="mb-0 oobaproduct-text">You could qualify for a bond of up to:</p>
                              </div>
                              <div
                                class="col-md-12 col-lg-5 col-6 m-0 px-3 px-lg-3 px-md-2 d-flex align-items-center justify-content-end">
                                <h3 class="text-green oobabalance">R {{ totalLoanAmount | number:'1.0-0' }}</h3>

                              </div>
                            </div>
                            <div class="d-flex flex-wrap w-100">
                              <div class="col-md-12 col-lg-7 col-6 m-0 ps-3 ps-lg-3 ps-md-2">
                                <p class="mb-0 oobaproduct-text">You will pay a monthly installment of:</p>

                              </div>
                              <div
                                class="col-md-12 col-lg-5 col-6 m-0 px-3 px-lg-3 px-md-2 d-flex align-items-center justify-content-end">
                                <h3 class="text-green oobabalance">R {{ totalMonthlyRepaymentAmount | number:'1.0-0'
                                  }}
                                </h3>

                              </div>
                            </div>
                            <div
                              class="buttonpanel oobabtnpanel W-100 mt-3 px-3 px-lg-3 px-md-2 flex-wrap justify-content-end">
                              <div
                                class="col-5 col-lg-5 col-md-12 ps-3 ps-md-0 pe-1 pe-xl-1 pe-md-2 mb-0 mb-md-2 mb-lg-0">
                                <button class="bank_button btn-black mb-0 w-100" id="btn_OobaCalculatorPopUp_Products"
                                  name="btn_OobaCalculatorPopUp_Products"
                                  (click)="calculatorPopUP()">Calculator</button>
                              </div>
                              <div class="col-md-12 col-lg-6 col-6 pe-0 ps-xl-2 pe-lg-0 ps-xl-1 ps-1 ps-md-0">
                                <button class="bank_button mb-0 ml-0 w-100 mr-0"
                                  (click)="generateOobaLeads(false,true,false)" id="{{oobaBtnName}}"
                                  name="{{oobaBtnName}}">{{buttonText ?
                                  buttonText : 'Call Me'}}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<section class="bg-grey pt-4 pb-4 b5containeradjust pb-md-5" style="display: none;">
  <div class="container">
    <div class="row mb-4">
      <div class="col-12 text-center text-md-left">
        <h2>Products</h2>
        <p class="page-text">The products below could be just what you need to achieve and protect your financial goals
          and dreams. Click the links below to apply, and one of our savvy coaches will be in touch with you shortly.
        </p>
      </div>
    </div>
    <div class="row align-items-stretch justify-content-center">

      <div class="col-md-6 col-lg-3 px-3 align-items-stretch d-flex mb-5">
        <div class="product-holder">
          <div class="bg_bank w-100 bg-blue d-flex align-content-center justify-content-center">
            <img src="../../assets/images/personal-loan.png" alt="" width="80px" height="90" />
          </div>
          <div class="content w-100">
            <h4 class="font-weight-bold mb-1">Personal Loans</h4>
            <p class="text-uppercase text-blue text-bank mb-1 font-weight-bold"></p>
            <p class="sm">With a personal loan of up to R250,000 from one of our trusted financial partners, your dreams
              could become a reality!</p>
          </div>
          <button class="bank_button" (click)="personalLoanOffer()" id="btn_PersonalLoans_SolutionPage"
            name="btn_PersonalLoans_SolutionPage">View
            Offer</button>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 px-3 align-items-stretch d-flex mb-5">
        <div class="product-holder">
          <div class="bg_bank w-100 bg-orange d-flex align-content-center justify-content-center">
            <img src="../../assets/images/debt-cons.png" alt="" width="80px" height="81px" />
          </div>
          <div class="content w-100">
            <h4 class="font-weight-bold mb-1">Debt Consolidation</h4>
            <p class="text-uppercase text-orange text-bank mb-1 font-weight-bold"></p>
            <p class="sm">Get immediate financial relief with a plan that is tailored to your needs.</p>
          </div>
          <button class="bank_button" *ngIf="userType != 3" (click)="debtConsolidationCallback()"
            id="btn_DebtConsolidationCallMe_SolutionPage" name="btn_DebtConsolidationCallMe_SolutionPage">Call
            me</button>
          <button class="bank_button" *ngIf="userType == 3" (click)="getDebtConsolidation()"
            id="btn_DebtConsolidationViewOffer_ProductPage" name="btn_DebtConsolidationViewOffer_ProductPage">View
            Offer</button>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 px-3 align-items-stretch d-flex mb-5">
        <div class="product-holder">
          <div class="bg_bank w-100 bg-darkgry d-flex align-content-center justify-content-center">
            <svg width="80" height="80" viewBox="0 0 104 90" fill="none" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <g clip-path="url(#clip0)">
                <path
                  d="M11.0915 69.6544H11.2716L11.2131 63.518L6.40916 44.923C8.47918 44.7484 11.2698 44.3934 11.2716 41.9478L6.04898 43.4354L3.16752 32.6503L12.8924 30.0254L32.8825 24.4965L86.7297 9.5924L89.4311 20.3775L80.2465 22.8488L62.7776 27.6296V27.8155C64.7583 27.8155 66.9482 28.0855 68.9007 27.7293C75.9385 26.4453 82.8556 22.6917 89.9714 22.0511C90.1574 24.2535 90.5711 27.8135 93.0329 27.8155C91.9182 22.2391 90.132 16.7849 88.7781 11.266C87.7932 7.25086 86.9774 3.30255 83.1279 1.20426C80.1975 -0.393112 77.1248 0.431362 74.1234 1.24615C70.8176 2.14361 67.518 3.06416 64.2184 3.98577C49.2204 8.17486 34.1938 12.2553 19.1956 16.4445C13.9651 17.9054 5.3853 18.4788 2.21288 23.5387C-0.541718 27.9321 1.59122 32.9269 2.74051 37.485C5.44771 48.2216 8.17832 58.9754 11.0915 69.6544ZM86.1895 8.1048C82.1661 8.66466 78.0368 10.2501 74.1234 11.373C67.4175 13.2972 60.6592 15.0272 53.9532 16.9515C46.7087 19.0303 39.3921 20.8476 32.1622 22.9808C25.3533 24.9898 18.4547 26.6805 11.6318 28.6382C9.65461 29.2055 7.67466 29.768 5.68879 30.3019C4.96187 30.4973 3.9505 31.0161 3.19351 30.8852C2.35382 30.7402 2.45007 29.3905 2.4473 28.7453C2.43734 26.4304 3.26428 24.3773 4.96857 22.8293C6.64591 21.3058 9.16336 20.9015 11.2716 20.3539C14.8851 19.4154 18.4805 18.38 22.0771 17.3742C35.8751 13.5157 49.6989 9.75574 63.498 5.90151C68.4989 4.50472 74.3328 1.90501 79.5261 1.96915C82.8304 2.00996 85.7486 4.7404 86.1895 8.1048ZM20.2762 29.5707C16.5849 30.1706 13.4851 33.2533 12.9465 37.1131C12.3976 41.0459 12.8924 45.4105 12.8924 49.3858V73.7453C12.8924 78.6105 12.0163 83.9073 15.954 87.4712C18.3629 89.6513 21.2434 89.5511 24.2382 89.5511H36.3043H76.6446H89.0709C91.2844 89.5511 93.7522 89.865 95.9144 89.3207C99.2772 88.4741 102.126 85.1489 102.381 81.5552C102.665 77.5709 102.398 73.4643 102.398 69.4684V45.2949C102.398 40.4834 103.3 34.8268 99.1558 31.4449C96.5683 29.3329 93.6236 29.4891 90.5117 29.4891H78.2655H39.3658H26.7594C24.6504 29.4891 22.3614 29.2317 20.2762 29.5707ZM20.6363 31.2184C26.6231 30.3277 33.312 31.1626 39.3658 31.1626H77.365H90.5117C93.1134 31.1626 95.685 30.9103 97.8954 32.6058C101.756 35.5669 100.777 40.9455 100.777 45.2949V78.2081C100.777 82.419 99.8982 86.7168 95.194 87.7531C93.1581 88.2017 90.7879 87.8775 88.7107 87.8775H76.2845H37.0246H24.2382C21.6436 87.8775 19.1592 88.0613 17.0416 86.2161C13.415 83.0558 14.5133 77.3717 14.5133 73.0015C14.5133 61.3283 13.7026 49.3092 14.5295 37.6709C14.7646 34.3619 17.5336 31.6802 20.6363 31.2184ZM79.8863 52.8199C76.2474 53.5301 76.6445 57.6346 76.6446 60.5428C76.6448 62.1029 76.661 63.9546 77.7844 65.152C78.7584 66.1898 80.0161 66.3073 81.327 66.3073C84.2962 66.3074 87.9839 66.9187 90.8718 66.2084C94.3415 65.3548 93.7533 61.085 93.7533 58.3114C93.7533 56.7597 93.7565 55.0898 92.6135 53.9098C91.5475 52.809 90.1228 52.7329 88.7107 52.7329C85.8916 52.7328 82.6572 52.279 79.8863 52.8199ZM80.2465 54.4676C82.7957 53.9916 85.76 54.4065 88.3506 54.4065C89.3643 54.4065 90.5594 54.277 91.371 55.0422C92.0927 55.7224 92.128 56.8166 92.1323 57.7536C92.1415 59.7291 92.9195 64.0208 90.3316 64.5698C87.771 65.1127 84.6619 64.6337 82.0474 64.6337C81.0214 64.6337 79.8404 64.7936 79.0269 64.0026C78.2638 63.2605 78.4456 62.0821 78.4456 61.1007C78.4456 59.0673 77.5683 54.9678 80.2465 54.4676ZM21.7169 73.9313L21.5368 77.6503H23.1576V73.9313H21.7169ZM25.859 73.9313V77.6503H27.4798L27.2997 73.9313H25.859ZM30.0011 77.6503H31.6219V73.9313C29.4799 74.1851 30.0011 75.6907 30.0011 77.6503ZM34.3233 77.6503H35.9441L35.764 73.9313C33.7758 74.1685 34.3233 75.8986 34.3233 77.6503ZM40.9866 73.9313L40.8065 77.6503H42.4274V73.9313H40.9866ZM45.1287 73.9313V77.6503H46.7495L46.5694 73.9313H45.1287ZM49.4509 73.9313L49.2708 77.6503H50.8916V73.9313H49.4509ZM53.7731 73.9313L53.593 77.6503H55.2138C55.2138 75.9672 55.7734 74.0906 53.7731 73.9313ZM60.0763 73.9313V77.6503H61.6971L61.517 73.9313H60.0763ZM64.3985 73.9313V77.6503H66.0193V74.1172L64.3985 73.9313ZM68.7206 73.9313L68.5406 77.6503H70.1614V73.9313H68.7206ZM72.8627 73.9313V77.6503H74.4836L74.3035 73.9313H72.8627ZM79.346 73.9313V77.6503H80.9668L80.7867 73.9313H79.346ZM83.4881 77.6503H85.1089V73.9313C82.9442 74.0772 83.4881 75.7764 83.4881 77.6503ZM87.9904 73.9313L87.8103 77.6503H89.4311C89.4311 75.9672 89.9905 74.0906 87.9904 73.9313ZM92.1325 73.9313V77.6503H93.7533C93.7533 75.8151 94.3076 74.0458 92.1325 73.9313Z"
                  fill="white" />
                <rect x="49.062" y="35.236" width="46.0795" height="8.6399" fill="url(#pattern0)" />
              </g>
              <defs>
                <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                  <use xlink:href="#image0" transform="translate(0 -0.0263162) scale(0.00657895 0.0350877)" />
                </pattern>
                <clipPath id="clip0">
                  <rect width="103.012" height="90" fill="white" />
                </clipPath>

              </defs>
            </svg>
          </div>
          <div class="content w-100">
            <h4 class="font-weight-bold mb-1">Credit Facility</h4>
            <p class="text-uppercase text-orange text-bank mb-1 font-weight-bold"></p>
            <p class="sm">A simple, safe and convenient online credit facility with a limit of up to R35,000, and access
              to over 2000 online stores. </p>
          </div>
          <a id="btn_Mobicred_Product" name="btn_Mobicred_Product" class="bank_button"
            href="https://url.za.m.mimecastprotect.com/s/sTbfCRgX94TgOzrgi9N1DH" target="_blank">Apply now</a>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 px-3 align-items-stretch d-flex mb-5">
        <div class="product-holder">
          <div class="bg_bank w-100 bg-darkblue d-flex align-content-center justify-content-center">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
              xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="80" height="80" x="0" y="0"
              viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
              <g
                transform="matrix(-1,4.898587196589413e-16,4.898587196589413e-16,1,512.0000839233398,-2.2737367544323206e-13)">
                <g xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m488.352 232.546c-14.363-7.5-29.437-13.586-44.802-18.089-3.975-1.162-8.142 1.113-9.307 5.088s1.113 8.142 5.088 9.307c14.426 4.228 28.583 9.944 42.079 16.991 1.493.779 2.887 1.687 4.196 2.685-8.189.082-16.242.426-22.486 1.634-13.958 2.701-16.888 9.799-16.888 15.277 0 15.413 20.757 28.934 44.42 28.934 2.141 0 4.256-.088 6.349-.228v7.03h-38.813c-9.049-13.155-24.2-21.802-41.338-21.802s-32.289 8.647-41.337 21.802h-215.328c-9.049-13.155-24.2-21.802-41.338-21.802s-32.289 8.647-41.337 21.802h-62.51v-17.87h10.1c4.142 0 7.5-3.357 7.5-7.5v-5.66h17.212c10.173 0 18.45-8.276 18.45-18.449v-6.456c0-3.809-1.156-7.47-3.342-10.589l-15.27-21.785h18.14c2.563 0 4.95-1.31 6.327-3.472 9.358-14.697 23.379-28.16 41.672-40.015 11.443-7.416 23.815-12.989 36.782-16.688-2.283 1.311-4.533 2.672-6.737 4.101-14.321 9.283-26.416 19.643-35.948 30.791-3.959 4.631-4.897 10.961-2.449 16.521 2.431 5.52 7.691 9.075 13.729 9.279 0 0 241.267 8.151 241.339 8.152.072 0 .144-.006.217-.008.205-.005.409-.013.609-.034l.025-.001c14.056-1.539 28.557-1.386 43.103.455 4.114.525 7.862-2.39 8.382-6.499s-2.39-7.862-6.5-8.382c-14.525-1.839-29.029-2.117-43.166-.83-11.833-11.043-23.407-21.695-34.44-31.697-26.438-23.954-60.594-38.196-96.174-40.102l-34.912-1.87c-33.017-1.762-64.839 6.613-92.019 24.226-18.694 12.114-33.433 25.917-43.868 41.074-24.944.108-27.163-.231-29.798.252-9.253 1.435-16.365 9.435-16.365 19.088v45.352c0 .029-.004.058-.004.087s.004.058.004.087v5.573h-7.08c-5.801 0-10.52 4.715-10.52 10.51v45.891c0 4.998 3.557 9.332 8.435 10.302l63.766 12.882c7.346 18.587 25.479 31.777 46.646 31.777 19.881 0 37.096-11.629 45.202-28.441h27.662c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-23.178c.295-2.195.461-4.43.461-6.705 0-4.621-.641-9.093-1.817-13.345h201.344c-1.176 4.252-1.817 8.724-1.817 13.345 0 2.275.167 4.51.461 6.705h-140.454c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h144.938c8.106 16.813 25.321 28.441 45.201 28.441 19.881 0 37.096-11.629 45.202-28.441h22.85c14.943 0 27.1-12.157 27.1-27.1v-52.61c-.001-16.425-9.063-31.356-23.649-38.971zm-367.187-34.49c-.17-.385.021-.607.122-.727 21.064-24.635 53.969-44.655 91.824-49.022l15.644.838c2.493 9.235 5.863 31.47-.042 52.861l-107.04-3.617c-.172-.006-.367-.012-.508-.333zm221.566 7.803-98.697-3.335c4.521-19.328 3.048-39.271.403-52.117 28.254 3.709 54.995 16.007 76.226 35.244 7.151 6.483 14.534 13.245 22.068 20.208zm-289.469 39.38v6.456c0 1.902-1.547 3.449-3.45 3.449h-17.212v-37.939c0-.68.171-1.315.45-1.889l19.587 27.944c.408.582.625 1.267.625 1.979zm-38.262 75.791v-4.855h55.518c-1.424 5.151-2.007 10.372-1.757 15.716zm103.847 43.635c-19.379 0-35.146-15.767-35.146-35.146s15.767-35.146 35.146-35.146c19.38 0 35.147 15.767 35.147 35.146s-15.767 35.146-35.147 35.146zm371.804-85.293c-16.952 0-28.065-8.688-29.304-13.154 3.105-1.802 12.948-2.714 29.304-2.714 1.773 0 3.534.063 5.274.177.704 2.511 1.075 5.141 1.075 7.833v7.607c-2.078.166-4.199.251-6.349.251zm-73.802 85.293c-19.379 0-35.146-15.767-35.146-35.146s15.767-35.146 35.146-35.146c19.38 0 35.147 15.767 35.147 35.146s-15.767 35.146-35.147 35.146zm68.051-28.441h-18.366c.295-2.195.461-4.43.461-6.705 0-4.621-.641-9.093-1.817-13.345h31.822v7.95c0 6.672-5.428 12.1-12.1 12.1z"
                    fill="#fff" data-original="#fff" style="" />
                  <path
                    d="m118.847 304.996c-13.522 0-24.523 11.001-24.523 24.522 0 13.522 11.001 24.523 24.523 24.523s24.523-11.001 24.523-24.523c0-13.521-11.001-24.522-24.523-24.522zm0 34.046c-5.251 0-9.523-4.272-9.523-9.523s4.272-9.522 9.523-9.522 9.523 4.271 9.523 9.522-4.272 9.523-9.523 9.523z"
                    fill="#fff" data-original="#000000" style="" />
                  <path
                    d="m416.849 304.996c-13.522 0-24.523 11.001-24.523 24.522 0 13.522 11.001 24.523 24.523 24.523s24.523-11.001 24.523-24.523c0-13.521-11.001-24.522-24.523-24.522zm0 34.046c-5.251 0-9.523-4.272-9.523-9.523s4.272-9.522 9.523-9.522 9.523 4.271 9.523 9.522-4.272 9.523-9.523 9.523z"
                    fill="#fff" data-original="#fff" style="" />
                  <path
                    d="m256 228.686c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h5.2c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5z"
                    fill="#fff" data-original="#fff" style="" />
                  <path
                    d="m143.907 228.686c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h5.2c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5z"
                    fill="#fff" data-original="#fff" style="" />
                </g>
              </g>
            </svg>

          </div>
          <div class="content w-100">
            <h4 class="font-weight-bold mb-1">Car Insurance</h4>
            <p class="text-uppercase text-darkblue text-bank mb-1 font-weight-bold"></p>
            <p class="sm">Join thousands of South Africans who are saving on car insurance. Free quotation, no
              obligation. Save today.</p>
          </div>
          <button class="bank_button" (click)="carInsuranceCallback()" id="btn_CarInsurance_SolutionPage"
            name="btn_CarInsurance_SolutionPage">Call
            me</button>
        </div>
      </div>

      <div class="col-md-6 col-lg-3  px-3 align-items-stretch d-flex mb-5">
        <div class="product-holder">
          <div class="bg_bank w-100 bg-blue d-flex align-content-center justify-content-center">
            <img width="80px" src="../../assets/images/tax-free.png" alt="" />
          </div>
          <div class="content w-100">
            <h4 class="font-weight-bold mb-1">Tax Free Investment</h4>
            <p class="text-uppercase text-darkblue text-bank mb-1 font-weight-bold"></p>
            <p class="sm">Build your wealth, tax free. Start today.</p>
          </div>
          <button class="bank_button" href="#" (click)="redirectToInvestment('tfsa')"
            id="btn_TaxFreeSavingsAccount_SolutionPage" name="btn_TaxFreeSavingsAccount_SolutionPage">View
            Offer</button>
        </div>
      </div>
      <div class="col-md-6 col-lg-3  px-3 align-items-stretch d-flex mb-5">
        <div class="product-holder">
          <div class="bg_bank w-100 bg-orange d-flex align-content-center justify-content-center">
            <img src="../../assets/images/retirement.png" alt="" width="80px" />

          </div>
          <div class="content w-100">
            <h4 class="font-weight-bold mb-1">Retirement Annuity</h4>
            <p class="text-uppercase text-darkblue text-bank mb-1 font-weight-bold"></p>
            <p class="sm">Boost your retirement savings with a flexible and transparent plan.</p>
          </div>
          <button class="bank_button" (click)="redirectToInvestment('ra')" id="btn_RetirementAnnuity_SolutionPage"
            name="btn_RetirementAnnuity_SolutionPage">View Offer</button>
        </div>
      </div>
      <div class="col-md-6 col-lg-3  px-3 align-items-stretch d-flex mb-5">
        <div class="product-holder">
          <div class="bg_bank w-100 bg-darkblue d-flex align-content-center justify-content-center">
            <img src="../../assets/images/unit-test.png" alt="" width="80px" />
          </div>
          <div class="content w-100">
            <h4 class="font-weight-bold mb-1">Targeted Investment</h4>
            <p class="text-uppercase text-darkblue text-bank mb-1 font-weight-bold"></p>
            <p class="sm">Meet your short-and long-term goals by investing in a wide range of assets.</p>
          </div>
          <button class="bank_button" href="#" (click)="redirectToInvestment('ut')" id="btn_UnitTrusts_SolutionPage"
            name="btn_UnitTrusts_SolutionPage">View Offer</button>
        </div>
      </div>

    </div>
  </div>
</section>

<section class="pb-4 bg-grey">
  <!-- <app-bureau-data-provided></app-bureau-data-provided> -->
</section>

<!-- Modal approved -->
<ng-template #lesApprovedModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title"><img src="assets/images/slogo.png" alt="" width="120px" /></h5>
    <button type="button" class="close" id="btn_SPLViewOffer_ProductPage_PopupClosed"
      name="btn_SPLViewOffer_ProductPage_PopupClosed" isCloseButton="true" (click)="modal.dismiss('Cross click')">
      <span id="btn_SPLViewOffer_ProductPage_PopupClosed" name="btn_SPLViewOffer_ProductPage_PopupClosed"
        aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex flex-wrap w-100">
      <div class="col-md-9 col-9">
        <h5 class="text-orange mb-1">Loan Amount</h5>
        <p>
          R 5,000 to R 350,000
        </p>

        <h5 class="text-orange mb-1">Loan Term</h5>
        <p>
          12 to 84 months
        </p>

        <h5 class="text-orange mb-1">Loan Interest Rate</h5>
        <p>
          16% to 28.50%
        </p>
      </div>
      <div class="col-md-3 col-3 align-self-end">
        <div class="d-flex justify-content-end spl_btn_container"><button type="button" class="bank_button mb-0"
            (click)="transferLead()" id="btn_LoanAmount_SolutionPage" name="btn_LoanAmount_SolutionPage">Go</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap py-0">

    <p class="w-100 mt-2 text-sm">Sanlam Personal Loans (Pty) Ltd, Reg No. 2001/016316/07
      Registered Credit Provider (NCRCP272)
      DirectAxis SA (Pty) Ltd is an authorised service provider (FSP license 7249)
      Refer to Sanlam website for directors and company secretary detail.</p>
  </div>
</ng-template>

<div class="modal fade" id="termcontent" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog  modal-dialog-scrollable" role="document">
    <div class="modal-content">

      <!--Keep this-->
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Terms & Conditions</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          id="btn_PersonalLoanTerms_Close_SolutionPage" name="btn_PersonalLoanTerms_Close_SolutionPage">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>
          Detailed below, is the complete list of Terms & Conditions that should be displayed to a customer when
          applying for a personal loan
        </p>
        <h5 class="text-orange">You confirm that</h5>
        <ul class="list-text">
          <li>You are not currently over-indebted</li>
          <li>You are not under administration, sequestration or debt review and have not been declared mentally unfit
            by an order of court</li>
          <li>All information you give us is true and correct</li>
          <li>You will ensure that you have read and understood the terms and conditions that follow before accepting
            any loan amount that you may be offered</li>
        </ul>
        <h5 class="text-orange">You agree that DirectAxis may</h5>
        <ul class="list-text">
          <li>Check and verify any information that we need in connection with this agreement</li>
          <li>May contact you by SMS or email about this or future applications</li>
        </ul>
        <h5 class="text-orange">English</h5>
        <p>You confirm that you are able to read and fully understand English. If you cannot read English or do not
          fully understand English, you should not carry on with this online personal loan application and should call
          us to apply in one of the other languages we support namely Afrikaans, Xhosa, Zulu or Sesotho.</p>

        <h5 class="text-orange">Afrikaans</h5>
        <p>U bevestig dat u Engels kan lees en Engels ten volle verstaan. Indien u nie Engels kan lees nie, óf Engels
          nie ten volle verstaan nie, moet u asseblief nie met hierdie aanlyn aansoek om ‘n persoonlike lening voortgaan
          nie. Skakel ons eerder: ons kan u telefonies in Afrikaans, Xhosa, Zulu of Sotho help om u aansoek te voltooi.
        </p>

        <h5 class="text-orange">Zulu</h5>
        <p>Uyaqinisekisa ukuthi uyakwazi ukufunda isiNgisi futhi usiqonda ngokuphelele. Uma ungakwazi ukufunda isiNgisi
          noma ungasiqondi ngokuphelele isiNgisi, akumele uqhubeke nokufaka isicelo sokubolekwa imali nge-inthanethi
          kodwa esikhundleni salokho kumele usifonele ukuze ufake isicelo sakho ngolunye lwezilimi esizisebenzisayo,
          isiBhunu, isiXhosa, isiZulu kanye neSesotho.</p>

        <h5 class="text-orange">Sesotho</h5>
        <p>O netefatsa hore o kgona ho bala mme o utlwisisa Senyesemane ka botlalo. Haeba o sa kgone ho bala Senyesemane
          kapa o sa utlwisise Senyesemane ka botlalo, o tlameha ho se tswele pele ka kopo ena ya mokitlane wa motho ya
          inthaneteng mme o re letsetse ho etsa kopo ka e nngwe ya tse ding tsa dipuo tseo re di sebedisang, e leng
          Afrikanse, Sexhosa, Sezulu kapa Sesotho.</p>

        <h5 class="text-orange">Xhosa</h5>
        <p>Uqinisekisa ukuba uyakwazi ukusithetha isiNgesi kwaye usiqonda ngokupheleleyo. Ukuba awukwazi ukusifunda
          isiNgesi okanye awusiqondi ngokupheleleyo, akufuneki uqhubeke ngesi sicelo semali-mboleko sifumaneka
          kwikhompyutha kwaye kufuneka ufake isicelo ngezinye iilwimi esizixhasayo ezizezi, isiBhulu, isiXhosa, isiZulu
          okanye isiSuthu.</p>


      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="bank_button mb-0 ms-0" (click)="transferLead()"
          id="btn_PersonalLoanTermsAgree_SolutionPage" name="btn_PersonalLoanTermsAgree_SolutionPage">Yes , I agree to
          the Terms and Condition</button>
        <button type="button" class="bank_button mb-0 me-0 bg-gry" data-dismiss="modal"
          id="btn_PersonalLoanTermsDecline_SolutionPage" name="btn_PersonalLoanTermsDecline_SolutionPage">No</button>
      </div>
      <!--Keep this-->

    </div>
  </div>
</div>
<!-- Modal approved -->


<!-- Modal Maybe or Declined -->
<ng-template #finCheckAgreeModal let-modal>
  <div class="modal-header">
    <button name="btn_FinCheckAgreePopupClose_Product" type="button" class="close" data-dismiss="modal"
      aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Do you give consent to send your details on to the third party providers and consent to pull a credit report?</p>
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="bank_button mb-0 ms-0" data-bs-toggle="modal" data-dismiss="modal"
      (click)="fincheckLead()" name="btn_PersonalLoanFincheckConsentAgree_SolutionPage">Yes , I agree please contact
      me</button>
    <button type="button" class="bank_button mb-0 me-0 bg-gry" data-dismiss="modal"
      (click)="modal.dismiss('Cross click')" name="btn_PersonalLoanFincheckConsentDisagree_SolutionPage">No</button>
  </div>
</ng-template>

<ng-template #finCheckSubmitModal let-modal>
  <div class="modal-header">
    <button name="btn_FinCheckSuccessPopupClose_Product" type="button" class="close" data-dismiss="modal"
      aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Thank you for your application. Please stay close to your phone and expect an SMS or phone call from one of our
      trusted financial partners.</p>
  </div>
</ng-template>

<ng-template #finCheckErrorModal let-modal>
  <div class="modal-header">
    <button name="btn_FinCheckErrorPopupClose_Product" type="button" class="close" data-dismiss="modal"
      aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Something went wrong, please try again after sometime.</p>
  </div>
</ng-template>
<!-- Modal Maybe or Declined -->

<ng-template #callbackConfirmationModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" class="close" aria-label="Close" id="callbackConfirmationClosed"
      name="callbackConfirmationClosed" isCloseButton="true" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="callbackErrorMsg!=''" class="alert alert-success" role="alert">
      {{callbackErrorMsg}}
    </div>
    <div *ngIf="callbackSuccessMsg!=''" class="alert alert-success" role="alert">
      {{callbackSuccessMsg}}
    </div>
    <div class="txthd" *ngIf="callbackErrorMsg==''">Do you want a Coach to call you now?</div>
  </div>
  <div class="modal-footer" *ngIf="callbackErrorMsg==''">
    <button id="btn_CallbackConfirmationPopUpNo_Product" name="btn_CallbackConfirmationPopUpNo_Product" type="button"
      class="btn-border" (click)="modal.dismiss('No')">No</button>
    <button id="btn_CallbackConfirmationPopUpYes_Product" name="btn_CallbackConfirmationPopUpYes_Product" type="button"
      class="btn btn-primary" (click)="userCallback(campaignSourceType)">Yes</button>
  </div>
</ng-template>

<!-- Debt Consolidation Text Modal -->
<ng-template #debtConsolidationModel let-modal>
  <form (ngSubmit)="leadCallback()">
    <div class="modal-header orangeheader">
      <h4 class="modal-title text-center text-white" id="modal-basic-title">Reduce your instalments and SAVE with
        JustMoney</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        name="btn_DebtConsolidationCallMe_ProductPage_ClosePopup" (click)="modal.dismiss('Cross click')">
        <svg enable-background="new 0 0 256 256" height="30px" id="Layer_1" version="1.1" viewBox="0 0 256 256"
          width="30px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <path
            d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
            fill="#fff" />
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-group mb-0 fullwidth">
        <div class="form-field  gi-hld">
          <div class="d-flex align-items-center mb-4">
            <div class="col-md-6 text-end">
              <svg data-name="Group 188" height="40" id="Group_188" viewBox="0 0 192.08 52.516" width="120"
                xmlns="http://www.w3.org/2000/svg">
                <g data-name="Group 54" id="Group_54" transform="translate(0 13.348)">
                  <path
                    d="M-565.9,291.362h1.891v16.295a6.926,6.926,0,0,1-1.867,5.09,6.49,6.49,0,0,1-4.83,1.891,7.164,7.164,0,0,1-5-1.67,6.045,6.045,0,0,1-1.765-4.886l.031-.094h1.765a5.126,5.126,0,0,0,1.269,3.822,5.08,5.08,0,0,0,3.7,1.237,4.505,4.505,0,0,0,3.451-1.457,5.549,5.549,0,0,0,1.355-3.932Z"
                    data-name="Path 140" fill="#e59a2c" id="Path_140" transform="translate(577.467 -291.362)"></path>
                  <path
                    d="M-541.22,313.5a5.842,5.842,0,0,1-2.2,2.3,6.382,6.382,0,0,1-3.271.8,5.2,5.2,0,0,1-4.223-1.828q-1.53-1.828-1.529-5.673v-9.882h1.891v9.913a7.334,7.334,0,0,0,1.063,4.475,3.613,3.613,0,0,0,3.018,1.356,5.513,5.513,0,0,0,3.4-.954,5.05,5.05,0,0,0,1.789-2.607V299.226h1.892v17.052h-1.671Z"
                    data-name="Path 141" fill="#e59a2c" id="Path_141" transform="translate(571.197 -293.332)"></path>
                  <path
                    d="M-518.427,311.807a2.733,2.733,0,0,0-.985-2.088,8.07,8.07,0,0,0-3.554-1.458,11.642,11.642,0,0,1-4.5-1.725,3.6,3.6,0,0,1-1.473-3.065,4.138,4.138,0,0,1,1.647-3.31,6.643,6.643,0,0,1,4.357-1.356,6.814,6.814,0,0,1,4.555,1.443,4.257,4.257,0,0,1,1.623,3.553l-.031.094h-1.749a3.139,3.139,0,0,0-1.206-2.442,4.715,4.715,0,0,0-3.191-1.04,4.615,4.615,0,0,0-3.089.9,2.7,2.7,0,0,0-1.039,2.1,2.437,2.437,0,0,0,.89,1.931,8.76,8.76,0,0,0,3.554,1.348,11.559,11.559,0,0,1,4.531,1.844,3.807,3.807,0,0,1,1.536,3.183,4.172,4.172,0,0,1-1.725,3.46,7.265,7.265,0,0,1-4.562,1.331,7.377,7.377,0,0,1-4.877-1.481,4.193,4.193,0,0,1-1.679-3.53l.031-.094h1.734a3.122,3.122,0,0,0,1.5,2.679,6.275,6.275,0,0,0,3.286.835,5.161,5.161,0,0,0,3.23-.913A2.7,2.7,0,0,0-518.427,311.807Z"
                    data-name="Path 142" fill="#e59a2c" id="Path_142" transform="translate(565.425 -293.227)"></path>
                  <path
                    d="M-504.143,293.4v4.366h3.75v1.545h-3.75v11.111a3.632,3.632,0,0,0,.606,2.371,2.028,2.028,0,0,0,1.615.7,5.557,5.557,0,0,0,.67-.039c.215-.026.47-.07.764-.134l.284,1.4a3.939,3.939,0,0,1-.938.307,5.372,5.372,0,0,1-1.111.118,3.534,3.534,0,0,1-2.8-1.134,5.35,5.35,0,0,1-1-3.593V299.311H-509v-1.545h2.947V293.4Z"
                    data-name="Path 143" fill="#e59a2c" id="Path_143" transform="translate(560.313 -291.873)"></path>
                </g>
                <g data-name="Group 55" id="Group_55" transform="translate(64.82 13.348)">
                  <path
                    d="M-479.6,310.006h.094l7.328-18.644h3.862v22.946h-3.105V297.114l-.094-.016-6.95,17.209h-2.159l-7.154-17.776-.1.016v17.761h-3.105V291.362h4.082Z"
                    data-name="Path 144" fill="#302e2f" id="Path_144" transform="translate(490.979 -291.362)"></path>
                  <path
                    d="M-455.1,307.489a9.388,9.388,0,0,1,2.049-6.233,6.869,6.869,0,0,1,5.563-2.452,6.936,6.936,0,0,1,5.6,2.443,9.354,9.354,0,0,1,2.057,6.241v.346a9.34,9.34,0,0,1-2.048,6.241,6.916,6.916,0,0,1-5.578,2.427,6.928,6.928,0,0,1-5.586-2.435,9.321,9.321,0,0,1-2.057-6.233Zm3.1.346a8.093,8.093,0,0,0,1.143,4.477,3.783,3.783,0,0,0,3.4,1.764,3.774,3.774,0,0,0,3.373-1.764,8.057,8.057,0,0,0,1.15-4.477v-.346a8.023,8.023,0,0,0-1.159-4.46,3.8,3.8,0,0,0-3.4-1.781,3.745,3.745,0,0,0-3.365,1.781,8.108,8.108,0,0,0-1.143,4.46Z"
                    data-name="Path 145" fill="#302e2f" id="Path_145" transform="translate(481.991 -293.227)"></path>
                  <path
                    d="M-426.888,299.121l.22,2.538a6.19,6.109,0,0,1,2.136-2.1,5.7,5.7,0,0,1,2.923-.749,5.565,5.565,0,0,1,4.27,1.616,7.091,7.091,0,0,1,1.513,4.988v10.764h-3.1v-10.7a4.613,4.613,0,0,0-.89-3.2,3.564,3.564,0,0,0-2.718-.946,4.806,4.806,0,0,0-2.435.576,4.177,4.177,0,0,0-1.584,1.615v12.655h-3.1V299.121Z"
                    data-name="Path 146" fill="#302e2f" id="Path_146" transform="translate(475.617 -293.227)"></path>
                  <path
                    d="M-398.367,316.5a7.214,7.214,0,0,1-5.728-2.347,9.036,9.036,0,0,1-2.057-6.179v-.693a8.846,8.846,0,0,1,2.119-6.076,6.644,6.644,0,0,1,5.177-2.4,6.188,6.188,0,0,1,5.13,2.128,8.77,8.77,0,0,1,1.71,5.658v1.639h-10.905l-.047.079a7.056,7.056,0,0,0,1.134,4.169,3.966,3.966,0,0,0,3.468,1.6,7.8,7.8,0,0,0,2.766-.449,6.174,6.174,0,0,0,2.041-1.237l1.214,2.018a7.461,7.461,0,0,1-2.412,1.489A9.6,9.6,0,0,1-398.367,316.5Zm-.489-15.255a3.375,3.375,0,0,0-2.687,1.253,5.933,5.933,0,0,0-1.3,3.207l.031.079h7.69v-.252a4.965,4.965,0,0,0-.914-3.074A3.3,3.3,0,0,0-398.856,301.248Z"
                    data-name="Path 147" fill="#302e2f" id="Path_147" transform="translate(469.727 -293.227)"></path>
                  <path
                    d="M-378.3,309.958l.552,2.143h.094l4.192-12.876h3.451l-7.17,19.667a8.831,8.831,0,0,1-1.852,2.994,4.262,4.262,0,0,1-3.254,1.277,6.8,6.8,0,0,1-.962-.087q-.583-.087-.9-.165l.315-2.442a3.952,3.952,0,0,1,.56.031q.653.047.827.046a1.915,1.915,0,0,0,1.623-.882,9.165,9.165,0,0,0,1.056-1.955l.741-1.781-6.335-16.7h3.467Z"
                    data-name="Path 148" fill="#302e2f" id="Path_148" transform="translate(464.518 -293.332)"></path>
                </g>
                <path
                  d="M-360.642,286.56a2.224,2.224,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.225,2.225,0,0,0-2.225,2.225"
                  data-name="Path 149" fill="#e59a2c" id="Path_149" transform="translate(523.145 -276.254)"></path>
                <path
                  d="M-349.466,286.56a2.225,2.225,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.225,2.225,0,0,0-2.225,2.225"
                  data-name="Path 150" fill="#e59a2c" id="Path_150" transform="translate(520.345 -276.254)"></path>
                <path
                  d="M-360.642,296.2a2.224,2.224,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.224,2.224,0,0,0-2.225,2.225"
                  data-name="Path 151" fill="#e59a2c" id="Path_151" transform="translate(523.145 -278.669)"></path>
                <path
                  d="M-349.466,296.2a2.225,2.225,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.225,2.225,0,0,0-2.225,2.225"
                  data-name="Path 152" fill="#e59a2c" id="Path_152" transform="translate(520.345 -278.669)"></path>
                <path
                  d="M-338.291,296.2a2.225,2.225,0,0,0,2.226,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.225,2.225,0,0,0-2.226,2.225"
                  data-name="Path 153" fill="#e59a2c" id="Path_153" transform="translate(517.545 -278.669)"></path>
                <path
                  d="M-360.642,305.845a2.225,2.225,0,0,0,2.225,2.226,2.226,2.226,0,0,0,2.225-2.226,2.225,2.225,0,0,0-2.225-2.224,2.224,2.224,0,0,0-2.225,2.224"
                  data-name="Path 154" fill="#e59a2c" id="Path_154" transform="translate(523.145 -281.085)"></path>
                <path
                  d="M-349.466,305.845a2.226,2.226,0,0,0,2.225,2.226,2.226,2.226,0,0,0,2.225-2.226,2.225,2.225,0,0,0-2.225-2.224,2.225,2.225,0,0,0-2.225,2.224"
                  data-name="Path 155" fill="#e59a2c" id="Path_155" transform="translate(520.345 -281.085)"></path>
                <path
                  d="M-338.291,305.845a2.226,2.226,0,0,0,2.226,2.226,2.226,2.226,0,0,0,2.225-2.226,2.225,2.225,0,0,0-2.225-2.224,2.225,2.225,0,0,0-2.226,2.224"
                  data-name="Path 156" fill="#e59a2c" id="Path_156" transform="translate(517.545 -281.085)"></path>
                <path
                  d="M-327.115,305.845a2.226,2.226,0,0,0,2.226,2.226,2.225,2.225,0,0,0,2.224-2.226,2.225,2.225,0,0,0-2.224-2.224,2.225,2.225,0,0,0-2.226,2.224"
                  data-name="Path 157" fill="#e59a2c" id="Path_157" transform="translate(514.745 -281.085)"></path>
                <path
                  d="M-360.642,315.489a2.224,2.224,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.226,2.225,2.225,0,0,0-2.225,2.226"
                  data-name="Path 158" fill="#e59a2c" id="Path_158" transform="translate(523.145 -283.501)"></path>
                <path
                  d="M-349.466,315.489a2.225,2.225,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.226,2.225,2.225,0,0,0-2.225,2.226"
                  data-name="Path 159" fill="#e59a2c" id="Path_159" transform="translate(520.345 -283.501)"></path>
                <path
                  d="M-338.291,315.489a2.225,2.225,0,0,0,2.226,2.225,2.225,2.225,0,0,0,2.225-2.225,2.226,2.226,0,0,0-2.225-2.226,2.225,2.225,0,0,0-2.226,2.226"
                  data-name="Path 160" fill="#e59a2c" id="Path_160" transform="translate(517.545 -283.501)"></path>
                <path
                  d="M-360.642,325.131a2.224,2.224,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.224,2.224,0,0,0-2.225,2.225"
                  data-name="Path 161" fill="#e59a2c" id="Path_161" transform="translate(523.145 -285.917)"></path>
                <path
                  d="M-349.466,325.131a2.225,2.225,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.225,2.225,0,0,0-2.225,2.225"
                  data-name="Path 162" fill="#e59a2c" id="Path_162" transform="translate(520.345 -285.917)"></path>
                <path
                  d="M-360.642,335.915a2.224,2.224,0,0,0,2.225,2.224,2.225,2.225,0,0,0,2.225-2.224,2.224,2.224,0,0,0-2.225-2.225,2.224,2.224,0,0,0-2.225,2.225"
                  data-name="Path 163" fill="#e59a2c" id="Path_163" transform="translate(523.145 -288.619)"></path>
                <path
                  d="M-360.642,275.777A2.224,2.224,0,0,0-358.417,278a2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.224,2.224,0,0,0-2.225,2.225"
                  data-name="Path 164" fill="#e59a2c" id="Path_164" transform="translate(523.145 -273.552)"></path>
                <g data-name="Group 56" id="Group_56" transform="translate(17.021 40.873)">
                  <path
                    d="M-549.633,335.2h-3.194l-.758,2.186h-1.172l3.061-8.487h.986l3,8.487h-1.172Zm-2.862-.962h2.535l-1.236-3.643h-.035Z"
                    data-name="Path 165" fill="#302e2f" id="Path_165" transform="translate(554.757 -328.292)"></path>
                  <path
                    d="M-544.256,334.145a4.206,4.206,0,0,1,.65-2.454,2.1,2.1,0,0,1,1.821-.932,2.264,2.264,0,0,1,.982.2,2.024,2.024,0,0,1,.732.594v-3.469h1.148v9.094h-.881l-.174-.8a2.057,2.057,0,0,1-.764.688,2.287,2.287,0,0,1-1.055.232,2.163,2.163,0,0,1-1.807-.836,3.475,3.475,0,0,1-.653-2.2Zm1.148.123a2.67,2.67,0,0,0,.391,1.53,1.365,1.365,0,0,0,1.213.575,1.517,1.517,0,0,0,.863-.233,1.737,1.737,0,0,0,.571-.654v-2.943a1.769,1.769,0,0,0-.574-.621,1.517,1.517,0,0,0-.848-.231,1.313,1.313,0,0,0-1.222.682,3.522,3.522,0,0,0-.394,1.772Z"
                    data-name="Path 166" fill="#302e2f" id="Path_166" transform="translate(552.126 -328.089)"></path>
                  <path
                    d="M-532.937,336.255l.1.443h.034l.111-.443,1.452-4.448h1.171l-2.32,6.307h-.869l-2.349-6.307h1.177Z"
                    data-name="Path 167" fill="#302e2f" id="Path_167" transform="translate(549.959 -329.021)"></path>
                  <path d="M-525.569,329.261h-1.149v-1.172h1.149Zm0,7.922h-1.149v-6.307h1.149Z" data-name="Path 168"
                    fill="#302e2f" id="Path_168" transform="translate(547.732 -328.089)"></path>
                  <path
                    d="M-520.41,337.3a1.35,1.35,0,0,0,.926-.353,1.115,1.115,0,0,0,.4-.866h1.037l.018.035a1.813,1.813,0,0,1-.7,1.448,2.47,2.47,0,0,1-1.678.633,2.477,2.477,0,0,1-2.053-.9,3.493,3.493,0,0,1-.722-2.251V334.8a3.472,3.472,0,0,1,.725-2.241,2.475,2.475,0,0,1,2.05-.907,2.376,2.376,0,0,1,1.727.653,2.073,2.073,0,0,1,.651,1.6l-.012.035h-1.043a1.392,1.392,0,0,0-.376-.982,1.238,1.238,0,0,0-.947-.4,1.327,1.327,0,0,0-1.234.656,3.066,3.066,0,0,0-.387,1.588v.244a3.127,3.127,0,0,0,.381,1.6A1.327,1.327,0,0,0-520.41,337.3Z"
                    data-name="Path 169" fill="#302e2f" id="Path_169" transform="translate(546.847 -328.982)"></path>
                  <path
                    d="M-511.969,338.2a2.67,2.67,0,0,1-2.119-.868,3.343,3.343,0,0,1-.761-2.286v-.256a3.272,3.272,0,0,1,.784-2.247,2.457,2.457,0,0,1,1.915-.889,2.288,2.288,0,0,1,1.9.787,3.24,3.24,0,0,1,.633,2.093v.606h-4.034l-.017.029a2.608,2.608,0,0,0,.42,1.542,1.467,1.467,0,0,0,1.282.592,2.883,2.883,0,0,0,1.023-.166,2.276,2.276,0,0,0,.755-.457l.45.746a2.772,2.772,0,0,1-.893.551A3.545,3.545,0,0,1-511.969,338.2Zm-.181-5.642a1.249,1.249,0,0,0-.994.463,2.191,2.191,0,0,0-.481,1.186l.012.028h2.845v-.093a1.833,1.833,0,0,0-.339-1.136A1.219,1.219,0,0,0-512.149,332.556Z"
                    data-name="Path 170" fill="#302e2f" id="Path_170" transform="translate(544.758 -328.982)"></path>
                  <path
                    d="M-500.492,335.777l.2.793h.035l1.551-4.763h1.277l-2.652,7.275a3.278,3.278,0,0,1-.685,1.108,1.579,1.579,0,0,1-1.2.473,2.572,2.572,0,0,1-.355-.032c-.144-.022-.254-.042-.333-.061l.117-.9a1.591,1.591,0,0,1,.207.011c.162.012.263.018.306.018a.709.709,0,0,0,.6-.327,3.35,3.35,0,0,0,.39-.722l.274-.659-2.344-6.179h1.282Z"
                    data-name="Path 171" fill="#302e2f" id="Path_171" transform="translate(541.816 -329.021)"></path>
                  <path
                    d="M-494.651,334.864a3.469,3.469,0,0,1,.757-2.305,2.54,2.54,0,0,1,2.058-.907,2.567,2.567,0,0,1,2.072.9,3.46,3.46,0,0,1,.761,2.308v.128a3.456,3.456,0,0,1-.758,2.308,2.56,2.56,0,0,1-2.064.9,2.564,2.564,0,0,1-2.066-.9,3.45,3.45,0,0,1-.76-2.305Zm1.148.128a2.993,2.993,0,0,0,.422,1.656,1.4,1.4,0,0,0,1.256.653,1.4,1.4,0,0,0,1.248-.653,2.981,2.981,0,0,0,.425-1.656v-.128a2.966,2.966,0,0,0-.428-1.65,1.4,1.4,0,0,0-1.256-.659,1.386,1.386,0,0,0-1.245.659,3,3,0,0,0-.422,1.65Z"
                    data-name="Path 172" fill="#302e2f" id="Path_172" transform="translate(539.698 -328.982)"></path>
                  <path
                    d="M-481.243,337.182a2.143,2.143,0,0,1-.764.781,2.094,2.094,0,0,1-1.078.274,2.024,2.024,0,0,1-1.608-.659,3.054,3.054,0,0,1-.577-2.051v-3.72h1.148v3.732a2.35,2.35,0,0,0,.3,1.387,1.107,1.107,0,0,0,.928.379,1.879,1.879,0,0,0,1.01-.248,1.546,1.546,0,0,0,.6-.7v-4.547h1.148v6.307h-1.032Z"
                    data-name="Path 173" fill="#302e2f" id="Path_173" transform="translate(537.348 -329.021)"></path>
                  <path
                    d="M-469.81,337.3a1.35,1.35,0,0,0,.927-.353,1.115,1.115,0,0,0,.4-.866h1.037l.017.035a1.81,1.81,0,0,1-.7,1.448,2.467,2.467,0,0,1-1.678.633,2.475,2.475,0,0,1-2.052-.9,3.489,3.489,0,0,1-.722-2.251V334.8a3.468,3.468,0,0,1,.725-2.241,2.473,2.473,0,0,1,2.049-.907,2.378,2.378,0,0,1,1.728.653,2.075,2.075,0,0,1,.65,1.6l-.012.035h-1.042a1.392,1.392,0,0,0-.376-.982,1.239,1.239,0,0,0-.947-.4,1.325,1.325,0,0,0-1.233.656,3.066,3.066,0,0,0-.387,1.588v.244a3.127,3.127,0,0,0,.381,1.6A1.327,1.327,0,0,0-469.81,337.3Z"
                    data-name="Path 174" fill="#302e2f" id="Path_174" transform="translate(534.17 -328.982)"></path>
                  <path
                    d="M-460.086,338.076q-.058-.286-.09-.5a3.731,3.731,0,0,1-.038-.44,2.668,2.668,0,0,1-.836.761,2.139,2.139,0,0,1-1.11.306,2.058,2.058,0,0,1-1.5-.5,1.852,1.852,0,0,1-.516-1.389,1.63,1.63,0,0,1,.732-1.414,3.418,3.418,0,0,1,1.985-.51h1.247v-.624a1.153,1.153,0,0,0-.338-.876,1.322,1.322,0,0,0-.956-.324,1.384,1.384,0,0,0-.9.28.837.837,0,0,0-.344.67l-1.09.012-.012-.035a1.508,1.508,0,0,1,.644-1.258,2.67,2.67,0,0,1,1.77-.572,2.6,2.6,0,0,1,1.725.545,1.931,1.931,0,0,1,.653,1.571v3.038a5.917,5.917,0,0,0,.034.653,3.407,3.407,0,0,0,.128.618Zm-1.906-.839a2.045,2.045,0,0,0,1.125-.321,1.519,1.519,0,0,0,.653-.734v-1.026H-461.5a1.669,1.669,0,0,0-1.111.349,1.046,1.046,0,0,0-.417.822.867.867,0,0,0,.262.665A1.1,1.1,0,0,0-461.992,337.236Z"
                    data-name="Path 175" fill="#302e2f" id="Path_175" transform="translate(532.064 -328.982)"></path>
                  <path
                    d="M-454.106,331.768l.082.939a2.3,2.3,0,0,1,.789-.779,2.114,2.114,0,0,1,1.082-.277,2.057,2.057,0,0,1,1.579.6,2.623,2.623,0,0,1,.56,1.845v3.981h-1.148v-3.958a1.707,1.707,0,0,0-.329-1.183,1.321,1.321,0,0,0-1.006-.35,1.785,1.785,0,0,0-.9.213,1.548,1.548,0,0,0-.586.6v4.681h-1.148v-6.307Z"
                    data-name="Path 176" fill="#302e2f" id="Path_176" transform="translate(529.797 -328.982)"></path>
                  <path _ngcontent-qyc-c3=""
                    d="M-436.734,334.268a3.463,3.463,0,0,1-.656,2.2,2.165,2.165,0,0,1-1.8.836,2.29,2.29,0,0,1-1.093-.247,2.032,2.032,0,0,1-.767-.731l-.186.857h-.881v-9.094h1.148v3.533a2,2,0,0,1,.737-.641,2.256,2.256,0,0,1,1.03-.222,2.1,2.1,0,0,1,1.818.932,4.2,4.2,0,0,1,.653,2.454Zm-1.148-.123a3.492,3.492,0,0,0-.4-1.769,1.317,1.317,0,0,0-1.216-.685,1.505,1.505,0,0,0-.9.26,1.83,1.83,0,0,0-.579.7v2.734a1.879,1.879,0,0,0,.579.728,1.5,1.5,0,0,0,.907.262,1.367,1.367,0,0,0,1.207-.577,2.654,2.654,0,0,0,.4-1.527Z"
                    data-name="Path 177" fill="#302e2f" id="Path_177" transform="translate(526.537 -328.089)"></path>
                  <path
                    d="M-429.263,338.076q-.057-.286-.09-.5a3.724,3.724,0,0,1-.037-.44,2.679,2.679,0,0,1-.837.761,2.139,2.139,0,0,1-1.11.306,2.058,2.058,0,0,1-1.5-.5,1.852,1.852,0,0,1-.516-1.389,1.63,1.63,0,0,1,.732-1.414,3.42,3.42,0,0,1,1.985-.51h1.248v-.624a1.154,1.154,0,0,0-.339-.876,1.321,1.321,0,0,0-.956-.324,1.385,1.385,0,0,0-.9.28.837.837,0,0,0-.344.67l-1.09.012-.012-.035a1.507,1.507,0,0,1,.645-1.258,2.666,2.666,0,0,1,1.769-.572,2.6,2.6,0,0,1,1.725.545,1.931,1.931,0,0,1,.653,1.571v3.038a5.733,5.733,0,0,0,.035.653,3.341,3.341,0,0,0,.128.618Zm-1.906-.839a2.049,2.049,0,0,0,1.126-.321,1.523,1.523,0,0,0,.653-.734v-1.026h-1.288a1.672,1.672,0,0,0-1.111.349,1.046,1.046,0,0,0-.417.822.867.867,0,0,0,.262.665A1.1,1.1,0,0,0-431.169,337.236Z"
                    data-name="Path 178" fill="#302e2f" id="Path_178" transform="translate(524.341 -328.982)"></path>
                  <path
                    d="M-423.283,331.768l.082.939a2.3,2.3,0,0,1,.79-.779,2.11,2.11,0,0,1,1.081-.277,2.057,2.057,0,0,1,1.579.6,2.623,2.623,0,0,1,.56,1.845v3.981h-1.148v-3.958a1.707,1.707,0,0,0-.329-1.183,1.32,1.32,0,0,0-1.006-.35,1.785,1.785,0,0,0-.9.213,1.546,1.546,0,0,0-.585.6v4.681h-1.149v-6.307Z"
                    data-name="Path 179" fill="#302e2f" id="Path_179" transform="translate(522.075 -328.982)"></path>
                  <path
                    d="M-413.51,334.274h-.588v2.909h-1.148v-9.094h1.148v5.27h.577l1.895-2.484h1.376l-2.292,2.909,2.49,3.4h-1.358Z"
                    data-name="Path 180" fill="#302e2f" id="Path_180" transform="translate(519.805 -328.089)"></path>
                  <path
                    d="M-403.486,334.864a3.473,3.473,0,0,1,.757-2.305,2.54,2.54,0,0,1,2.058-.907,2.567,2.567,0,0,1,2.072.9,3.46,3.46,0,0,1,.761,2.308v.128a3.456,3.456,0,0,1-.758,2.308,2.56,2.56,0,0,1-2.064.9,2.564,2.564,0,0,1-2.066-.9,3.454,3.454,0,0,1-.76-2.305Zm1.148.128a2.993,2.993,0,0,0,.422,1.656,1.4,1.4,0,0,0,1.256.653,1.4,1.4,0,0,0,1.248-.653,2.981,2.981,0,0,0,.426-1.656v-.128a2.966,2.966,0,0,0-.429-1.65,1.4,1.4,0,0,0-1.256-.659,1.386,1.386,0,0,0-1.245.659,3,3,0,0,0-.422,1.65Z"
                    data-name="Path 181" fill="#302e2f" id="Path_181" transform="translate(516.858 -328.982)"></path>
                  <path
                    d="M-393.05,331.768l.081.939a2.307,2.307,0,0,1,.79-.779,2.112,2.112,0,0,1,1.081-.277,2.057,2.057,0,0,1,1.58.6,2.623,2.623,0,0,1,.56,1.845v3.981h-1.148v-3.958a1.706,1.706,0,0,0-.33-1.183,1.319,1.319,0,0,0-1.005-.35,1.788,1.788,0,0,0-.9.213,1.552,1.552,0,0,0-.585.6v4.681h-1.148v-6.307Z"
                    data-name="Path 182" fill="#302e2f" id="Path_182" transform="translate(514.5 -328.982)"></path>
                </g>
              </svg>
            </div>
            <div class="col-md-6"><img src="../../assets/images/dblogojm.png" alt="" /></div>
          </div>
          <div class="d-flex align-items-center  pt-3">
            <div class="col-md-8 text-end">
              <p>Your current monthly debt repayment: </p>
            </div>
            <div class="col-md-6">
              <p><span class="text-orange">R{{monthlyInstalment | number}}</span></p>
            </div>
          </div>
          <div class="d-flex align-items-center ">
            <div class="col-md-8 text-end">
              <p>Estimated new monthly payment: </p>
            </div>
            <div class="col-md-6">
              <p><span class="text-orange">R{{dbc_Dcrs | number}}</span></p>
            </div>
          </div>
          <div class="d-flex align-items-center pb-1">
            <div class="col-md-8 text-end">
              <p class="fonthighlight">Estimated monthly SAVING: </p>
            </div>
            <div class="col-md-6">
              <p class="fonthighlight"><span class="text-green">R{{(monthlyInstalment - dbc_Dcrs) | number}}</span></p>
            </div>
          </div>
          <div class="d-flex justify-content-center pt-2 pb-3">
            <button id="btn_DebtConsolidationCallMe_ProductPage_APPLYNOW"
              name="btn_DebtConsolidationCallMe_ProductPage_APPLYNOW" type="submit" class="btn-primary mx-1">Apply
              Now</button>
            <button id="btn_DebtConsolidationCallMe_ProductPage_CallMe"
              name="btn_DebtConsolidationCallMe_ProductPage_CallMe" type="submit" class="btn-primary mx-1">Call
              Me</button>
          </div>

        </div>
      </div>
    </div>
    <div class="modal-footer py-2">
      <p class="ofxt mb-0 text-center">Offer subject to change by the solution provider after further assessment. By
        clicking &#8220;Apply Now&#8221; you agree to the DebtBusters&#39; <a name="btn_TermsCondition_Product"
          class="textcolorgrylink" href="" target="_blank" routerLink="/terms">Terms and Conditions</a>. </p>
    </div>
  </form>
</ng-template>


<!-- Debt Consolidation Text Modal -->
<ng-template #creditLifeModel let-modal>
  <form (ngSubmit)="leadCallback()">
    <div class="modal-header orangeheader">
      <h4 class="modal-title text-center text-white" id="modal-basic-title">Pay affordable premiums with JustMoney</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        name="btn_CreditLifeViewOffer_ProductPage_Close" (click)="modal.dismiss('Cross click')">
        <svg enable-background="new 0 0 256 256" height="30px" id="Layer_1" version="1.1" viewBox="0 0 256 256"
          width="30px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <path
            d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
            fill="#fff" />
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-group mb-0 fullwidth">
        <div class="form-field  gi-hld">
          <div class="d-flex align-items-center justify-content-center mb-4">
            <div class="col-md-6 text-center">
              <svg data-name="Group 188" height="40" id="Group_188" viewBox="0 0 192.08 52.516" width="120"
                xmlns="http://www.w3.org/2000/svg">
                <g data-name="Group 54" id="Group_54" transform="translate(0 13.348)">
                  <path
                    d="M-565.9,291.362h1.891v16.295a6.926,6.926,0,0,1-1.867,5.09,6.49,6.49,0,0,1-4.83,1.891,7.164,7.164,0,0,1-5-1.67,6.045,6.045,0,0,1-1.765-4.886l.031-.094h1.765a5.126,5.126,0,0,0,1.269,3.822,5.08,5.08,0,0,0,3.7,1.237,4.505,4.505,0,0,0,3.451-1.457,5.549,5.549,0,0,0,1.355-3.932Z"
                    data-name="Path 140" fill="#e59a2c" id="Path_140" transform="translate(577.467 -291.362)"></path>
                  <path
                    d="M-541.22,313.5a5.842,5.842,0,0,1-2.2,2.3,6.382,6.382,0,0,1-3.271.8,5.2,5.2,0,0,1-4.223-1.828q-1.53-1.828-1.529-5.673v-9.882h1.891v9.913a7.334,7.334,0,0,0,1.063,4.475,3.613,3.613,0,0,0,3.018,1.356,5.513,5.513,0,0,0,3.4-.954,5.05,5.05,0,0,0,1.789-2.607V299.226h1.892v17.052h-1.671Z"
                    data-name="Path 141" fill="#e59a2c" id="Path_141" transform="translate(571.197 -293.332)"></path>
                  <path
                    d="M-518.427,311.807a2.733,2.733,0,0,0-.985-2.088,8.07,8.07,0,0,0-3.554-1.458,11.642,11.642,0,0,1-4.5-1.725,3.6,3.6,0,0,1-1.473-3.065,4.138,4.138,0,0,1,1.647-3.31,6.643,6.643,0,0,1,4.357-1.356,6.814,6.814,0,0,1,4.555,1.443,4.257,4.257,0,0,1,1.623,3.553l-.031.094h-1.749a3.139,3.139,0,0,0-1.206-2.442,4.715,4.715,0,0,0-3.191-1.04,4.615,4.615,0,0,0-3.089.9,2.7,2.7,0,0,0-1.039,2.1,2.437,2.437,0,0,0,.89,1.931,8.76,8.76,0,0,0,3.554,1.348,11.559,11.559,0,0,1,4.531,1.844,3.807,3.807,0,0,1,1.536,3.183,4.172,4.172,0,0,1-1.725,3.46,7.265,7.265,0,0,1-4.562,1.331,7.377,7.377,0,0,1-4.877-1.481,4.193,4.193,0,0,1-1.679-3.53l.031-.094h1.734a3.122,3.122,0,0,0,1.5,2.679,6.275,6.275,0,0,0,3.286.835,5.161,5.161,0,0,0,3.23-.913A2.7,2.7,0,0,0-518.427,311.807Z"
                    data-name="Path 142" fill="#e59a2c" id="Path_142" transform="translate(565.425 -293.227)"></path>
                  <path
                    d="M-504.143,293.4v4.366h3.75v1.545h-3.75v11.111a3.632,3.632,0,0,0,.606,2.371,2.028,2.028,0,0,0,1.615.7,5.557,5.557,0,0,0,.67-.039c.215-.026.47-.07.764-.134l.284,1.4a3.939,3.939,0,0,1-.938.307,5.372,5.372,0,0,1-1.111.118,3.534,3.534,0,0,1-2.8-1.134,5.35,5.35,0,0,1-1-3.593V299.311H-509v-1.545h2.947V293.4Z"
                    data-name="Path 143" fill="#e59a2c" id="Path_143" transform="translate(560.313 -291.873)"></path>
                </g>
                <g data-name="Group 55" id="Group_55" transform="translate(64.82 13.348)">
                  <path
                    d="M-479.6,310.006h.094l7.328-18.644h3.862v22.946h-3.105V297.114l-.094-.016-6.95,17.209h-2.159l-7.154-17.776-.1.016v17.761h-3.105V291.362h4.082Z"
                    data-name="Path 144" fill="#302e2f" id="Path_144" transform="translate(490.979 -291.362)"></path>
                  <path
                    d="M-455.1,307.489a9.388,9.388,0,0,1,2.049-6.233,6.869,6.869,0,0,1,5.563-2.452,6.936,6.936,0,0,1,5.6,2.443,9.354,9.354,0,0,1,2.057,6.241v.346a9.34,9.34,0,0,1-2.048,6.241,6.916,6.916,0,0,1-5.578,2.427,6.928,6.928,0,0,1-5.586-2.435,9.321,9.321,0,0,1-2.057-6.233Zm3.1.346a8.093,8.093,0,0,0,1.143,4.477,3.783,3.783,0,0,0,3.4,1.764,3.774,3.774,0,0,0,3.373-1.764,8.057,8.057,0,0,0,1.15-4.477v-.346a8.023,8.023,0,0,0-1.159-4.46,3.8,3.8,0,0,0-3.4-1.781,3.745,3.745,0,0,0-3.365,1.781,8.108,8.108,0,0,0-1.143,4.46Z"
                    data-name="Path 145" fill="#302e2f" id="Path_145" transform="translate(481.991 -293.227)"></path>
                  <path
                    d="M-426.888,299.121l.22,2.538a6.19,6.19,0,0,1,2.136-2.1,5.7,5.7,0,0,1,2.923-.749,5.565,5.565,0,0,1,4.27,1.616,7.091,7.091,0,0,1,1.513,4.988v10.764h-3.1v-10.7a4.613,4.613,0,0,0-.89-3.2,3.564,3.564,0,0,0-2.718-.946,4.806,4.806,0,0,0-2.435.576,4.177,4.177,0,0,0-1.584,1.615v12.655h-3.1V299.121Z"
                    data-name="Path 146" fill="#302e2f" id="Path_146" transform="translate(475.617 -293.227)"></path>
                  <path
                    d="M-398.367,316.5a7.214,7.214,0,0,1-5.728-2.347,9.036,9.036,0,0,1-2.057-6.179v-.693a8.846,8.846,0,0,1,2.119-6.076,6.644,6.644,0,0,1,5.177-2.4,6.188,6.188,0,0,1,5.13,2.128,8.77,8.77,0,0,1,1.71,5.658v1.639h-10.905l-.047.079a7.056,7.056,0,0,0,1.134,4.169,3.966,3.966,0,0,0,3.468,1.6,7.8,7.8,0,0,0,2.766-.449,6.174,6.174,0,0,0,2.041-1.237l1.214,2.018a7.461,7.461,0,0,1-2.412,1.489A9.6,9.6,0,0,1-398.367,316.5Zm-.489-15.255a3.375,3.375,0,0,0-2.687,1.253,5.933,5.933,0,0,0-1.3,3.207l.031.079h7.69v-.252a4.965,4.965,0,0,0-.914-3.074A3.3,3.3,0,0,0-398.856,301.248Z"
                    data-name="Path 147" fill="#302e2f" id="Path_147" transform="translate(469.727 -293.227)"></path>
                  <path
                    d="M-378.3,309.958l.552,2.143h.094l4.192-12.876h3.451l-7.17,19.667a8.831,8.831,0,0,1-1.852,2.994,4.262,4.262,0,0,1-3.254,1.277,6.8,6.8,0,0,1-.962-.087q-.583-.087-.9-.165l.315-2.442a3.952,3.952,0,0,1,.56.031q.653.047.827.046a1.915,1.915,0,0,0,1.623-.882,9.165,9.165,0,0,0,1.056-1.955l.741-1.781-6.335-16.7h3.467Z"
                    data-name="Path 148" fill="#302e2f" id="Path_148" transform="translate(464.518 -293.332)"></path>
                </g>
                <path
                  d="M-360.642,286.56a2.224,2.224,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.225,2.225,0,0,0-2.225,2.225"
                  data-name="Path 149" fill="#e59a2c" id="Path_149" transform="translate(523.145 -276.254)"></path>
                <path
                  d="M-349.466,286.56a2.225,2.225,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.225,2.225,0,0,0-2.225,2.225"
                  data-name="Path 150" fill="#e59a2c" id="Path_150" transform="translate(520.345 -276.254)"></path>
                <path
                  d="M-360.642,296.2a2.224,2.224,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.224,2.224,0,0,0-2.225,2.225"
                  data-name="Path 151" fill="#e59a2c" id="Path_151" transform="translate(523.145 -278.669)"></path>
                <path
                  d="M-349.466,296.2a2.225,2.225,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.225,2.225,0,0,0-2.225,2.225"
                  data-name="Path 152" fill="#e59a2c" id="Path_152" transform="translate(520.345 -278.669)"></path>
                <path
                  d="M-338.291,296.2a2.225,2.225,0,0,0,2.226,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.225,2.225,0,0,0-2.226,2.225"
                  data-name="Path 153" fill="#e59a2c" id="Path_153" transform="translate(517.545 -278.669)"></path>
                <path
                  d="M-360.642,305.845a2.225,2.225,0,0,0,2.225,2.226,2.226,2.226,0,0,0,2.225-2.226,2.225,2.225,0,0,0-2.225-2.224,2.224,2.224,0,0,0-2.225,2.224"
                  data-name="Path 154" fill="#e59a2c" id="Path_154" transform="translate(523.145 -281.085)"></path>
                <path
                  d="M-349.466,305.845a2.226,2.226,0,0,0,2.225,2.226,2.226,2.226,0,0,0,2.225-2.226,2.225,2.225,0,0,0-2.225-2.224,2.225,2.225,0,0,0-2.225,2.224"
                  data-name="Path 155" fill="#e59a2c" id="Path_155" transform="translate(520.345 -281.085)"></path>
                <path
                  d="M-338.291,305.845a2.226,2.226,0,0,0,2.226,2.226,2.226,2.226,0,0,0,2.225-2.226,2.225,2.225,0,0,0-2.225-2.224,2.225,2.225,0,0,0-2.226,2.224"
                  data-name="Path 156" fill="#e59a2c" id="Path_156" transform="translate(517.545 -281.085)"></path>
                <path
                  d="M-327.115,305.845a2.226,2.226,0,0,0,2.226,2.226,2.225,2.225,0,0,0,2.224-2.226,2.225,2.225,0,0,0-2.224-2.224,2.225,2.225,0,0,0-2.226,2.224"
                  data-name="Path 157" fill="#e59a2c" id="Path_157" transform="translate(514.745 -281.085)"></path>
                <path
                  d="M-360.642,315.489a2.224,2.224,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.226,2.225,2.225,0,0,0-2.225,2.226"
                  data-name="Path 158" fill="#e59a2c" id="Path_158" transform="translate(523.145 -283.501)"></path>
                <path
                  d="M-349.466,315.489a2.225,2.225,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.226,2.225,2.225,0,0,0-2.225,2.226"
                  data-name="Path 159" fill="#e59a2c" id="Path_159" transform="translate(520.345 -283.501)"></path>
                <path
                  d="M-338.291,315.489a2.225,2.225,0,0,0,2.226,2.225,2.225,2.225,0,0,0,2.225-2.225,2.226,2.226,0,0,0-2.225-2.226,2.225,2.225,0,0,0-2.226,2.226"
                  data-name="Path 160" fill="#e59a2c" id="Path_160" transform="translate(517.545 -283.501)"></path>
                <path
                  d="M-360.642,325.131a2.224,2.224,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.224,2.224,0,0,0-2.225,2.225"
                  data-name="Path 161" fill="#e59a2c" id="Path_161" transform="translate(523.145 -285.917)"></path>
                <path
                  d="M-349.466,325.131a2.225,2.225,0,0,0,2.225,2.225,2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.225,2.225,0,0,0-2.225,2.225"
                  data-name="Path 162" fill="#e59a2c" id="Path_162" transform="translate(520.345 -285.917)"></path>
                <path
                  d="M-360.642,335.915a2.224,2.224,0,0,0,2.225,2.224,2.225,2.225,0,0,0,2.225-2.224,2.224,2.224,0,0,0-2.225-2.225,2.224,2.224,0,0,0-2.225,2.225"
                  data-name="Path 163" fill="#e59a2c" id="Path_163" transform="translate(523.145 -288.619)"></path>
                <path
                  d="M-360.642,275.777A2.224,2.224,0,0,0-358.417,278a2.225,2.225,0,0,0,2.225-2.225,2.225,2.225,0,0,0-2.225-2.225,2.224,2.224,0,0,0-2.225,2.225"
                  data-name="Path 164" fill="#e59a2c" id="Path_164" transform="translate(523.145 -273.552)"></path>
                <g data-name="Group 56" id="Group_56" transform="translate(17.021 40.873)">
                  <path
                    d="M-549.633,335.2h-3.194l-.758,2.186h-1.172l3.061-8.487h.986l3,8.487h-1.172Zm-2.862-.962h2.535l-1.236-3.643h-.035Z"
                    data-name="Path 165" fill="#302e2f" id="Path_165" transform="translate(554.757 -328.292)"></path>
                  <path
                    d="M-544.256,334.145a4.206,4.206,0,0,1,.65-2.454,2.1,2.1,0,0,1,1.821-.932,2.264,2.264,0,0,1,.982.2,2.024,2.024,0,0,1,.732.594v-3.469h1.148v9.094h-.881l-.174-.8a2.057,2.057,0,0,1-.764.688,2.287,2.287,0,0,1-1.055.232,2.163,2.163,0,0,1-1.807-.836,3.475,3.475,0,0,1-.653-2.2Zm1.148.123a2.67,2.67,0,0,0,.391,1.53,1.365,1.365,0,0,0,1.213.575,1.517,1.517,0,0,0,.863-.233,1.737,1.737,0,0,0,.571-.654v-2.943a1.769,1.769,0,0,0-.574-.621,1.517,1.517,0,0,0-.848-.231,1.313,1.313,0,0,0-1.222.682,3.522,3.522,0,0,0-.394,1.772Z"
                    data-name="Path 166" fill="#302e2f" id="Path_166" transform="translate(552.126 -328.089)"></path>
                  <path
                    d="M-532.937,336.255l.1.443h.034l.111-.443,1.452-4.448h1.171l-2.32,6.307h-.869l-2.349-6.307h1.177Z"
                    data-name="Path 167" fill="#302e2f" id="Path_167" transform="translate(549.959 -329.021)"></path>
                  <path d="M-525.569,329.261h-1.149v-1.172h1.149Zm0,7.922h-1.149v-6.307h1.149Z" data-name="Path 168"
                    fill="#302e2f" id="Path_168" transform="translate(547.732 -328.089)"></path>
                  <path
                    d="M-520.41,337.3a1.35,1.35,0,0,0,.926-.353,1.115,1.115,0,0,0,.4-.866h1.037l.018.035a1.813,1.813,0,0,1-.7,1.448,2.47,2.47,0,0,1-1.678.633,2.477,2.477,0,0,1-2.053-.9,3.493,3.493,0,0,1-.722-2.251V334.8a3.472,3.472,0,0,1,.725-2.241,2.475,2.475,0,0,1,2.05-.907,2.376,2.376,0,0,1,1.727.653,2.073,2.073,0,0,1,.651,1.6l-.012.035h-1.043a1.392,1.392,0,0,0-.376-.982,1.238,1.238,0,0,0-.947-.4,1.327,1.327,0,0,0-1.234.656,3.066,3.066,0,0,0-.387,1.588v.244a3.127,3.127,0,0,0,.381,1.6A1.327,1.327,0,0,0-520.41,337.3Z"
                    data-name="Path 169" fill="#302e2f" id="Path_169" transform="translate(546.847 -328.982)"></path>
                  <path
                    d="M-511.969,338.2a2.67,2.67,0,0,1-2.119-.868,3.343,3.343,0,0,1-.761-2.286v-.256a3.272,3.272,0,0,1,.784-2.247,2.457,2.457,0,0,1,1.915-.889,2.288,2.288,0,0,1,1.9.787,3.24,3.24,0,0,1,.633,2.093v.606h-4.034l-.017.029a2.608,2.608,0,0,0,.42,1.542,1.467,1.467,0,0,0,1.282.592,2.883,2.883,0,0,0,1.023-.166,2.276,2.276,0,0,0,.755-.457l.45.746a2.772,2.772,0,0,1-.893.551A3.545,3.545,0,0,1-511.969,338.2Zm-.181-5.642a1.249,1.249,0,0,0-.994.463,2.191,2.191,0,0,0-.481,1.186l.012.028h2.845v-.093a1.833,1.833,0,0,0-.339-1.136A1.219,1.219,0,0,0-512.149,332.556Z"
                    data-name="Path 170" fill="#302e2f" id="Path_170" transform="translate(544.758 -328.982)"></path>
                  <path
                    d="M-500.492,335.777l.2.793h.035l1.551-4.763h1.277l-2.652,7.275a3.278,3.278,0,0,1-.685,1.108,1.579,1.579,0,0,1-1.2.473,2.572,2.572,0,0,1-.355-.032c-.144-.022-.254-.042-.333-.061l.117-.9a1.591,1.591,0,0,1,.207.011c.162.012.263.018.306.018a.709.709,0,0,0,.6-.327,3.35,3.35,0,0,0,.39-.722l.274-.659-2.344-6.179h1.282Z"
                    data-name="Path 171" fill="#302e2f" id="Path_171" transform="translate(541.816 -329.021)"></path>
                  <path
                    d="M-494.651,334.864a3.469,3.469,0,0,1,.757-2.305,2.54,2.54,0,0,1,2.058-.907,2.567,2.567,0,0,1,2.072.9,3.46,3.46,0,0,1,.761,2.308v.128a3.456,3.456,0,0,1-.758,2.308,2.56,2.56,0,0,1-2.064.9,2.564,2.564,0,0,1-2.066-.9,3.45,3.45,0,0,1-.76-2.305Zm1.148.128a2.993,2.993,0,0,0,.422,1.656,1.4,1.4,0,0,0,1.256.653,1.4,1.4,0,0,0,1.248-.653,2.981,2.981,0,0,0,.425-1.656v-.128a2.966,2.966,0,0,0-.428-1.65,1.4,1.4,0,0,0-1.256-.659,1.386,1.386,0,0,0-1.245.659,3,3,0,0,0-.422,1.65Z"
                    data-name="Path 172" fill="#302e2f" id="Path_172" transform="translate(539.698 -328.982)"></path>
                  <path
                    d="M-481.243,337.182a2.143,2.143,0,0,1-.764.781,2.094,2.094,0,0,1-1.078.274,2.024,2.024,0,0,1-1.608-.659,3.054,3.054,0,0,1-.577-2.051v-3.72h1.148v3.732a2.35,2.35,0,0,0,.3,1.387,1.107,1.107,0,0,0,.928.379,1.879,1.879,0,0,0,1.01-.248,1.546,1.546,0,0,0,.6-.7v-4.547h1.148v6.307h-1.032Z"
                    data-name="Path 173" fill="#302e2f" id="Path_173" transform="translate(537.348 -329.021)"></path>
                  <path
                    d="M-469.81,337.3a1.35,1.35,0,0,0,.927-.353,1.115,1.115,0,0,0,.4-.866h1.037l.017.035a1.81,1.81,0,0,1-.7,1.448,2.467,2.467,0,0,1-1.678.633,2.475,2.475,0,0,1-2.052-.9,3.489,3.489,0,0,1-.722-2.251V334.8a3.468,3.468,0,0,1,.725-2.241,2.473,2.473,0,0,1,2.049-.907,2.378,2.378,0,0,1,1.728.653,2.075,2.075,0,0,1,.65,1.6l-.012.035h-1.042a1.392,1.392,0,0,0-.376-.982,1.239,1.239,0,0,0-.947-.4,1.325,1.325,0,0,0-1.233.656,3.066,3.066,0,0,0-.387,1.588v.244a3.127,3.127,0,0,0,.381,1.6A1.327,1.327,0,0,0-469.81,337.3Z"
                    data-name="Path 174" fill="#302e2f" id="Path_174" transform="translate(534.17 -328.982)"></path>
                  <path
                    d="M-460.086,338.076q-.058-.286-.09-.5a3.731,3.731,0,0,1-.038-.44,2.668,2.668,0,0,1-.836.761,2.139,2.139,0,0,1-1.11.306,2.058,2.058,0,0,1-1.5-.5,1.852,1.852,0,0,1-.516-1.389,1.63,1.63,0,0,1,.732-1.414,3.418,3.418,0,0,1,1.985-.51h1.247v-.624a1.153,1.153,0,0,0-.338-.876,1.322,1.322,0,0,0-.956-.324,1.384,1.384,0,0,0-.9.28.837.837,0,0,0-.344.67l-1.09.012-.012-.035a1.508,1.508,0,0,1,.644-1.258,2.67,2.67,0,0,1,1.77-.572,2.6,2.6,0,0,1,1.725.545,1.931,1.931,0,0,1,.653,1.571v3.038a5.917,5.917,0,0,0,.034.653,3.407,3.407,0,0,0,.128.618Zm-1.906-.839a2.045,2.045,0,0,0,1.125-.321,1.519,1.519,0,0,0,.653-.734v-1.026H-461.5a1.669,1.669,0,0,0-1.111.349,1.046,1.046,0,0,0-.417.822.867.867,0,0,0,.262.665A1.1,1.1,0,0,0-461.992,337.236Z"
                    data-name="Path 175" fill="#302e2f" id="Path_175" transform="translate(532.064 -328.982)"></path>
                  <path
                    d="M-454.106,331.768l.082.939a2.3,2.3,0,0,1,.789-.779,2.114,2.114,0,0,1,1.082-.277,2.057,2.057,0,0,1,1.579.6,2.623,2.623,0,0,1,.56,1.845v3.981h-1.148v-3.958a1.707,1.707,0,0,0-.329-1.183,1.321,1.321,0,0,0-1.006-.35,1.785,1.785,0,0,0-.9.213,1.548,1.548,0,0,0-.586.6v4.681h-1.148v-6.307Z"
                    data-name="Path 176" fill="#302e2f" id="Path_176" transform="translate(529.797 -328.982)"></path>
                  <path _ngcontent-qyc-c3=""
                    d="M-436.734,334.268a3.463,3.463,0,0,1-.656,2.2,2.165,2.165,0,0,1-1.8.836,2.29,2.29,0,0,1-1.093-.247,2.032,2.032,0,0,1-.767-.731l-.186.857h-.881v-9.094h1.148v3.533a2,2,0,0,1,.737-.641,2.256,2.256,0,0,1,1.03-.222,2.1,2.1,0,0,1,1.818.932,4.2,4.2,0,0,1,.653,2.454Zm-1.148-.123a3.492,3.492,0,0,0-.4-1.769,1.317,1.317,0,0,0-1.216-.685,1.505,1.505,0,0,0-.9.26,1.83,1.83,0,0,0-.579.7v2.734a1.879,1.879,0,0,0,.579.728,1.5,1.5,0,0,0,.907.262,1.367,1.367,0,0,0,1.207-.577,2.654,2.654,0,0,0,.4-1.527Z"
                    data-name="Path 177" fill="#302e2f" id="Path_177" transform="translate(526.537 -328.089)"></path>
                  <path
                    d="M-429.263,338.076q-.057-.286-.09-.5a3.724,3.724,0,0,1-.037-.44,2.679,2.679,0,0,1-.837.761,2.139,2.139,0,0,1-1.11.306,2.058,2.058,0,0,1-1.5-.5,1.852,1.852,0,0,1-.516-1.389,1.63,1.63,0,0,1,.732-1.414,3.42,3.42,0,0,1,1.985-.51h1.248v-.624a1.154,1.154,0,0,0-.339-.876,1.321,1.321,0,0,0-.956-.324,1.385,1.385,0,0,0-.9.28.837.837,0,0,0-.344.67l-1.09.012-.012-.035a1.507,1.507,0,0,1,.645-1.258,2.666,2.666,0,0,1,1.769-.572,2.6,2.6,0,0,1,1.725.545,1.931,1.931,0,0,1,.653,1.571v3.038a5.733,5.733,0,0,0,.035.653,3.341,3.341,0,0,0,.128.618Zm-1.906-.839a2.049,2.049,0,0,0,1.126-.321,1.523,1.523,0,0,0,.653-.734v-1.026h-1.288a1.672,1.672,0,0,0-1.111.349,1.046,1.046,0,0,0-.417.822.867.867,0,0,0,.262.665A1.1,1.1,0,0,0-431.169,337.236Z"
                    data-name="Path 178" fill="#302e2f" id="Path_178" transform="translate(524.341 -328.982)"></path>
                  <path
                    d="M-423.283,331.768l.082.939a2.3,2.3,0,0,1,.79-.779,2.11,2.11,0,0,1,1.081-.277,2.057,2.057,0,0,1,1.579.6,2.623,2.623,0,0,1,.56,1.845v3.981h-1.148v-3.958a1.707,1.707,0,0,0-.329-1.183,1.32,1.32,0,0,0-1.006-.35,1.785,1.785,0,0,0-.9.213,1.546,1.546,0,0,0-.585.6v4.681h-1.149v-6.307Z"
                    data-name="Path 179" fill="#302e2f" id="Path_179" transform="translate(522.075 -328.982)"></path>
                  <path
                    d="M-413.51,334.274h-.588v2.909h-1.148v-9.094h1.148v5.27h.577l1.895-2.484h1.376l-2.292,2.909,2.49,3.4h-1.358Z"
                    data-name="Path 180" fill="#302e2f" id="Path_180" transform="translate(519.805 -328.089)"></path>
                  <path
                    d="M-403.486,334.864a3.473,3.473,0,0,1,.757-2.305,2.54,2.54,0,0,1,2.058-.907,2.567,2.567,0,0,1,2.072.9,3.46,3.46,0,0,1,.761,2.308v.128a3.456,3.456,0,0,1-.758,2.308,2.56,2.56,0,0,1-2.064.9,2.564,2.564,0,0,1-2.066-.9,3.454,3.454,0,0,1-.76-2.305Zm1.148.128a2.993,2.993,0,0,0,.422,1.656,1.4,1.4,0,0,0,1.256.653,1.4,1.4,0,0,0,1.248-.653,2.981,2.981,0,0,0,.426-1.656v-.128a2.966,2.966,0,0,0-.429-1.65,1.4,1.4,0,0,0-1.256-.659,1.386,1.386,0,0,0-1.245.659,3,3,0,0,0-.422,1.65Z"
                    data-name="Path 181" fill="#302e2f" id="Path_181" transform="translate(516.858 -328.982)"></path>
                  <path
                    d="M-393.05,331.768l.081.939a2.307,2.307,0,0,1,.79-.779,2.112,2.112,0,0,1,1.081-.277,2.057,2.057,0,0,1,1.58.6,2.623,2.623,0,0,1,.56,1.845v3.981h-1.148v-3.958a1.706,1.706,0,0,0-.33-1.183,1.319,1.319,0,0,0-1.005-.35,1.788,1.788,0,0,0-.9.213,1.552,1.552,0,0,0-.585.6v4.681h-1.148v-6.307Z"
                    data-name="Path 182" fill="#302e2f" id="Path_182" transform="translate(514.5 -328.982)"></path>
                </g>
              </svg>
            </div>
            <!-- <div class="col-md-6"><img src="../../assets/images/dblogojm.png" alt=""/></div> -->
          </div>
          <div class="d-flex align-items-center  pt-3">
            <div class="col-md-8 text-end">
              <p>Your current premium value: </p>
            </div>
            <div class="col-md-6">
              <p><span class="text-orange">R {{currentPremium | number}}</span></p>
            </div>
          </div>
          <div class="d-flex align-items-center ">
            <div class="col-md-8 text-end">
              <p>Your potential new premium value: </p>
            </div>
            <div class="col-md-6">
              <p><span class="text-orange">R {{ourInsurance | number}}</span></p>
            </div>
          </div>
          <div class="d-flex align-items-center pb-1">
            <div class="col-md-8 text-end">
              <p class="fonthighlight">Your potential saving: </p>
            </div>
            <div class="col-md-6">
              <p class="fonthighlight"><span class="text-green">R{{(currentPremium - ourInsurance) | number}}</span></p>
            </div>
          </div>
          <div class="d-flex justify-content-center pt-2 pb-3">
            <button name="btn_CreditLife_ProductPage_CALLNOW"
              (click)="creditLifeInsuraceCallSuccess() ; modal.dismiss('Cross click')" type="submit"
              class="btn-primary mx-auto">Call me</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- monthly expenses Modal -->

<ng-template #monthlyExpenses let-modal>
  <div class="modal-header orangeheader">
    <h4 class="modal-title text-white" id="modal-basic-title">Your monthly expenses</h4>
    <button type="button" id="btn_MonthlyExpenses_ProductPage_ClosePopup" class="close" data-dismiss="modal"
      aria-label="Close" name="btn_MonthlyExpenses_ProductPage_ClosePopup" isCloseButton="true"
      (click)="modal.dismiss('Cross click')">
      <svg enable-background="new 0 0 256 256" height="30px" id="Layer_1" version="1.1" viewBox="0 0 256 256"
        width="30px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path
          d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
          fill="#fff" />
      </svg>
    </button>
  </div>
  <form [formGroup]="monthlyExpensesForm" (ngSubmit)="saveMonthlyExpenses()">
    <div class="modal-body">
      <div *ngIf="monthlyExpensesErrorMsg!=''" class="alert alert-danger" role="alert">
        {{monthlyExpensesErrorMsg}}
      </div>
      <div class="form-group mb-0 fullwidth">
        <div class="form-field  gi-hld">
          <div class="infoxt">
            <p class="text-orange text-bold ptext-popup">Why should you provide your monthly expenses? </p>
            <p class="ptext-popup">We need to know your monthly expenses in order to calculate the car what you can
              afford. </p>
            <div class="expenceholder">

              <label class="monthexpence">Monthly expenses (excluding debt/ credit repayments)</label>
              <input type="text" class="form-control" appCurrencyMask placeholder="R10,000" id="monthlyExpenses"
                isRequired="true" formControlName="MonthlyExpenses" (blur)="changeMonthlyExpenses()" />
              <div
                *ngIf="monthlyExpensesFormControls.MonthlyExpenses.touched && monthlyExpensesFormControls.MonthlyExpenses.errors"
                class="invalid-feedback">
                <div *ngIf="monthlyExpensesFormControls.MonthlyExpenses.errors.required">Monthly expense is required
                </div>
                <div *ngIf="monthlyExpensesFormControls.MonthlyExpenses.errors.min">Invalid monthly expense</div>
              </div>

            </div>
          </div>
          <div class="d-flex justify-content-end pt-2 pb-3">
            <button id="btn_MonthlyExpenses_ProductPage_Continue" type="submit" class="btn btn-orange"
              name="btn_MonthlyExpenses_ProductPage_Continue" data-dismiss="modal" aria-label="Close">Continue</button>
          </div>
        </div>
      </div>
    </div>
  </form>

</ng-template>


<!-- finance indicator Modal -->
<ng-template #financeIndicator let-modal>
  <form>
    <div class="modal-header orangeheader">
      <h4 class="modal-title text-center text-white" id="modal-basic-title">Vehicle Finance Indicator</h4>
      <button type="button" id="btn_FinanceIndicator_ProductPage_ClosePopup" class="close" data-dismiss="modal"
        aria-label="Close" name="btn_FinanceIndicator_ProductPage_ClosePopup" isCloseButton="true"
        (click)="modal.dismiss('Cross click')">
        <svg enable-background="new 0 0 256 256" height="30px" id="Layer_1" version="1.1" viewBox="0 0 256 256"
          width="30px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <path
            d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
            fill="#fff" />
        </svg>
      </button>
    </div>

    <div class="modal-body p-0">
      <div class="form-group mb-0 fullwidth">
        <div class="form-field gi-hld">

          <div class="chance-succes" *ngIf="categoryType != 3">
            <div class="d-flex flex-wrap justify-content-center pt-4 px-3">
              <div class="col-md-6">
                <p class="text-success text-center text-bold mb-0 actxt" *ngIf="categoryType == 1">Congratulations!</p>
                <p class="ptext-popup text-center" *ngIf="categoryType == 1">You have a good chance to qualify for
                  vehicle finance. </p>
                <p class="ptext-popup text-center" *ngIf="categoryType == 2">You have a chance to qualify for vehicle
                  finance. </p>

              </div>
              <div class="col-md-12">
                <p class="text-center">Speak to your dealership for more insights.</p>
              </div>
            </div>
            <hr class="divider my-0" />

            <div class="d-flex align-items-center  pt-3">
              <div class="col-lg-8 col-md-10 col-8 px-3">
                <p class="m-0">Estimated amount you could qualify for: </p>
              </div>
              <div class="col-lg-4 col-md-2 col-4 ps-0 pe-3">
                <p class="m-0 text-end"><span class="text-bold">R {{vehiclePrice | number}}</span></p>
              </div>
            </div>
            <hr class="divider" />
            <div class="d-flex align-items-center ">
              <div class="col-lg-8 col-md-10 col-8 px-3">
                <p class="m-0">Estimated monthly repayment you can afford: </p>
              </div>
              <div class="col-lg-4 col-md-2 col-4 ps-0 pe-3">
                <p class="m-0 text-end"><span class="text-bold">R {{maxMonthlyInstallment | number}}</span></p>
              </div>
            </div>
            <hr />
            <p class="ofxt mb-0 text-center px-3 mb-3">We assumed an interest rate of {{categoryType == 1 ? '11' :
              '13'}}% and a term of 6 years for this calculation. Actual values and T’s and C’s will depend on your
              chosen vehicle finance provider. </p>

          </div>

          <div class="chance-low" *ngIf="categoryType == 3">
            <div class="d-flex flex-wrap justify-content-center pt-3 px-3">

              <div class="col-md-12 px-0">
                <p class="ptext-popup">You don’t automatically qualify, but let’s talk – we may be able to get you those
                  wheels that you want. Request a FREE call-back from one of our coaches.</p>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center pt-2 pb-3">
            <button id="btn_FinanceIndicator_ProductPage_ViewFullProfile"
              name="btn_FinanceIndicator_ProductPage_ViewFullProfile" type="button" class="btn-orange mx-auto"
              (click)="modal.dismiss('Cross click')">View your full profile</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #callbackSuccessModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" id="callbackSuccessModelClosed" class="close" data-dismiss="modal"
      name="callbackSuccessModelClosed" isCloseButton="true" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span id="callbackSuccessModelClosed" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" class="alert alert-success" role="alert">
    <p class="m-0">Our coach will contact you shortly.</p>
  </div>
</ng-template>

<ng-template #callbackErrorModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="callbackErrorModelClosed"
      name="callbackErrorModelClosed" isCloseButton="true" (click)="modal.dismiss('Cross click')">
      <span id="callbackErrorModelClosed" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" class="alert alert-success" role="alert">
    <p>{{callBackErrorDebt}}</p>
  </div>
</ng-template>
<ng-template #lesDeclineModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title"></h4>
    <button type="button" class="close" id="lesDeclineModal_Declined_PopUpclosed" data-dismiss="modal"
      name="lesDeclineModal_Declined_PopUpclosed" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span id="lesDeclineModal_Declined_PopUpclosed" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Your application with Sanlam Personal Loans is still in progress. You should receive feedback shortly. Please
      feel free tot chat to your coach if you have any questions?</p>
  </div>
</ng-template>

<ng-template #carInsuranceConfirmationModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"
      id="carInsuranceConfirmationModelClosed" name="carInsuranceConfirmationModelClosed" isCloseButton="true">
      <span id="carInsuranceConfirmationModelClosed" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="txthd" *ngIf="callbackErrorMsg==''">Do you want a consultant to call you now?</div>
  </div>
  <div class="modal-footer" *ngIf="callbackErrorMsg==''">
    <button id="btn_CarInsuranceConfirmationYes_Product" name="btn_CarInsuranceConfirmationYes_Product" type="button"
      class="btn-border" (click)="modal.dismiss('No')">No</button>
    <button id="btn_CarInsuranceConfirmationNo_Product" name="btn_CarInsuranceConfirmationNo_Product" type="button"
      class="btn btn-primary" (click)="carInsuranceCallback()">Yes</button>
  </div>
</ng-template>

<ng-template #carInsuranceSuccessModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="carInsuranceSuccessModel"
      name="carInsuranceSuccessModel" isCloseButton="true" (click)="modal.dismiss('Cross click')">
      <span id="carInsuranceSuccessModel" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" class="alert alert-success" role="alert">
    <p>Our consultant will contact you shortly.</p>
  </div>
</ng-template>


<ng-template #oobaCalculatorModel let-modal>
  <div class="modal-header darkblue">
    <h4 class="modal-title text-white d-flex align-items-center"><i class="pe-md-3 pe-2"><img
          src="../../assets/images/homeicon.png" alt="" width="50px" /></i> Home Loan Calculator</h4>
    <button type="button" class="close text-white oobaCalcCloseBtn" data-dismiss="modal" aria-label="Close"
      id="carInsuranceSuccessModel" name="carInsuranceSuccessModel" isCloseButton="true"
      (click)="modal.dismiss('Cross click'); toggleOobaCalculationHide(); toogleOobaJointCalculationHide()">
      <svg fill="#ffffff" height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve">
        <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490 
      489.292,457.678 277.331,245.004 489.292,32.337 " />
      </svg>
    </button>
  </div>
  <div class="modal-body oobacalculator" id="accordion-info">

    <h4 class="mb-4 fontbold text-center text-orange popupcaption"> Who is this home loan for?</h4>
    <div class="col-md-9 col-12 px-md-3 px-0 mb-4 mx-auto">
      <ul class="nav oobaTab  rounded-pill d-flex justify-content-between bordorange" id="myTab" role="tablist">
        <li class="nav-item col-6 text-center px-0 ">
          <a class="nav-link active  border-radius-right-0 " id="justMe-tab" data-bs-toggle="tab" href="#justMe"
            role="tab" aria-controls="justMe" aria-selected="true">Just Me</a>
        </li>
        <li class="nav-item col-6 text-center  px-0 ">
          <a class="nav-link border-radius-left-0 " id="jointApplication-tab" data-bs-toggle="tab"
            href="#jointApplication" role="tab" aria-controls="jointApplication" aria-selected="false">Joint
            Application</a>
        </li>

      </ul>
    </div>
    <div class="tab-content" id="myTabContent">
      <div class="tab-pane fade show active" id="justMe" role="tabpanel" aria-labelledby="justMe-tab">
        <form [formGroup]="oobaCalculatorForm" id="oobaCalculatorForm" (ngSubmit)="calculateOobaAffordability()">
          <div class="d-flex flex-wrap align-items-stretch">
            <div class="col-md-7 col-12 ps-md-0 ps-0 pe-md-3 pe-0">
              <div class="form-group mb-2">
                <label for="GrossMonthlyIncome" class="m-0">
                  Gross Income
                  <a class="collapsed arrow" role="button" (click)="isGrossIncomeCollapsed = !isGrossIncomeCollapsed"
                    [attr.aria-expanded]="!isGrossIncomeCollapsed" aria-controls="grossIncomeinfo"
                    id="lnkgrossIncomeinfo">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path
                          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
                          id="info" />
                      </defs>
                      <use fill-rule="nonzero" xlink:href="#info" />
                    </svg>
                  </a>
                </label>
                <div>

                </div>
                <div [ngbCollapse]="isGrossIncomeCollapsed" class="collapse infobox" id="grossIncomeinfo"
                  data-bs-parent="#accordion-info">
                  <div class="card card-body p-3 text-sm border-0 text-white ">
                    <a class="closeinfo" role="button" (click)="isGrossIncomeCollapsed = true" aria-expanded="false"
                      aria-controls="grossIncomeinfo" id="lnkgrossIncomeinfoClose">
                      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                          <path id="cross"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </defs>
                        <use fill="#ffffff" fill-rule="nonzero" xlink:href="#cross" />
                      </svg>
                    </a>
                    Your gross monthly income is your total monthly earnings before tax and other deductions.
                    It includes your salary and any other income, such as rental earnings or a pension.
                    If you’re applying with a partner, please enter your combined income.
                  </div>
                </div>

                <input type="text" class="form-control" placeholder="R 22,000" appCurrencyMask
                  formControlName="GrossMonthlyIncome">
                <div
                  *ngIf="oobaCalculatorFormControls.GrossMonthlyIncome.touched && oobaCalculatorFormControls.GrossMonthlyIncome.errors"
                  class="invalid-feedback">
                  <div
                    *ngIf="oobaCalculatorFormControls.GrossMonthlyIncome.errors.required && validationErrorGrossIncome === ''">
                    Gross Income is required</div>
                  <div
                    *ngIf="oobaCalculatorFormControls.GrossMonthlyIncome.errors.min && validationErrorGrossIncome === ''">
                    Gross income must be more than 0 to continue.</div>
                </div>
                <div *ngIf="validationErrorGrossIncome != ''" class="invalid-feedback">
                  <div>{{ validationErrorGrossIncome }}</div>
                </div>
              </div>
              <div class="form-group mb-2">
                <label for="NetMonthlyIncome" class="m-0">
                  Net Income
                  <a class="collapsed arrow" role="button" (click)="isNetIncomeCollapsed = !isNetIncomeCollapsed"
                    [attr.aria-expanded]="!isNetIncomeCollapsed" aria-controls="netIncomeinfo" id="lnknetIncomeinfo">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path
                          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
                          id="info" />
                      </defs>
                      <use fill-rule="nonzero" xlink:href="#info" />
                    </svg>
                  </a>
                </label>

                <div [ngbCollapse]="isNetIncomeCollapsed" class="collapse infobox" id="netIncomeinfo"
                  data-bs-parent="#accordion-info">
                  <div class="card card-body p-3 text-sm border-0 text-white ">
                    <a class="closeinfo" role="button" (click)="isNetIncomeCollapsed = true" aria-expanded="false"
                      aria-controls="netIncomeinfo" id="lnknetIncomeinfoClose">
                      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                          <path id="cross"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </defs>
                        <use fill="#ffffff" fill-rule="nonzero" xlink:href="#cross" />
                      </svg>
                    </a>
                    Your net monthly income is your earnings after tax and other salary deductions,
                    such as medical aid and retirement contributions.
                  </div>
                </div>
                <input type="text" class="form-control" placeholder="R 20,000" appCurrencyMask
                  formControlName="NetMonthlyIncome"
                  (input)="updateNetSurplusIncome(oobaCalculatorForm, 'NetMonthlyIncome', 'NetSurplusIncome', 'TotalMonthlyExpenses')">
                <div
                  *ngIf="oobaCalculatorFormControls.NetMonthlyIncome.touched && oobaCalculatorFormControls.NetMonthlyIncome.errors"
                  class="invalid-feedback">
                  <div
                    *ngIf="oobaCalculatorFormControls.NetMonthlyIncome.errors.required && validationErrorNetIncome === ''">
                    Net Income is required</div>
                  <div
                    *ngIf="oobaCalculatorFormControls.NetMonthlyIncome.errors.min && validationErrorNetIncome === ''">
                    Net income must be more than 0 to continue.
                  </div>
                </div>
                <div *ngIf="validationErrorNetIncome != ''" class="invalid-feedback">
                  <div>{{ validationErrorNetIncome }}</div>
                </div>
              </div>
              <div class="form-group mb-2">
                <label for="netIncome" class="m-0">
                  Total Monthly Expenses
                  <a class="collapsed arrow" role="button"
                    (click)="isMonthlyExpensesCollapsed = !isMonthlyExpensesCollapsed"
                    [attr.aria-expanded]="!isMonthlyExpensesCollapsed" aria-controls="monthlyExpensesinfo"
                    id="lnkmonthlyExpensesinfo">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path
                          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
                          id="info" />
                      </defs>
                      <use fill-rule="nonzero" xlink:href="#info" />
                    </svg>
                  </a>
                </label>

                <div [ngbCollapse]="isMonthlyExpensesCollapsed" class="collapse infobox" id="monthlyExpensesinfo"
                  data-bs-parent="#accordion-info">
                  <div class="card card-body p-3 text-sm border-0 text-white ">
                    <a class="closeinfo" role="button" (click)="isMonthlyExpensesCollapsed = true" aria-expanded="false"
                      aria-controls="monthlyExpensesinfo" id="lnkmonthlyExpensesinfoClose">
                      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                          <path id="cross"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </defs>
                        <use fill="#ffffff" fill-rule="nonzero" xlink:href="#cross" />
                      </svg>
                    </a>
                    These include fixed expenses, such as rent and school fees,
                    and variable expenses, such as utilities and groceries.
                  </div>
                </div>
                <input type="text" class="form-control" placeholder="R 10,000" appCurrencyMask
                  formControlName="TotalMonthlyExpenses"
                  (input)="updateNetSurplusIncome(oobaCalculatorForm, 'NetMonthlyIncome', 'NetSurplusIncome', 'TotalMonthlyExpenses')">
                <div
                  *ngIf="oobaCalculatorFormControls.TotalMonthlyExpenses.touched && oobaCalculatorFormControls.TotalMonthlyExpenses.errors"
                  class="invalid-feedback">
                  <div
                    *ngIf="oobaCalculatorFormControls.TotalMonthlyExpenses.errors.required && validationErrorMonthlyExpenses == ''">
                    Total Monthly Expenses is required</div>
                  <div
                    *ngIf="oobaCalculatorFormControls.TotalMonthlyExpenses.errors.min && validationErrorMonthlyExpenses == ''">
                    Expenses must be more than 0 to continue.</div>
                </div>
                <div *ngIf="validationErrorMonthlyExpenses != ''" class="invalid-feedback">
                  <div>{{ validationErrorMonthlyExpenses }}</div>
                </div>
              </div>
              <div class="form-group mb-4">
                <label for="netsurplus" class="m-0">
                  Net Surplus Income
                  <a class="collapsed arrow" role="button" (click)="isNetSurplusCollapsed = !isNetSurplusCollapsed"
                    [attr.aria-expanded]="!isNetSurplusCollapsed" aria-controls="netSurplusinfo" id="lnknetSurplusinfo">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path
                          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
                          id="info" />
                      </defs>
                      <use fill-rule="nonzero" xlink:href="#info" />
                    </svg>
                  </a>
                </label>

                <div [ngbCollapse]="isNetSurplusCollapsed" class="collapse infobox" id="netSurplusinfo"
                  data-bs-parent="#accordion-info">
                  <div class="card card-body p-3 text-sm border-0 text-white ">
                    <a class="closeinfo" role="button" (click)="isNetSurplusCollapsed = true" aria-expanded="false"
                      aria-controls="netSurplusinfo" id="lnknetSurplusinfoClose">
                      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                          <path id="cross"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </defs>
                        <use fill="#ffffff" fill-rule="nonzero" xlink:href="#cross" />
                      </svg>
                    </a>
                    This is the money you have left after you have deducted your
                    monthly expenses from your net income.
                  </div>
                </div>
                <input type="text" class="form-control disabled" placeholder="R 10,000" appCurrencyMask
                  formControlName="NetSurplusIncome" readonly>
              </div>
              <div class="form-group row mb-3">
                <label for="interestRate" class="col-md-4 col-5 col-form-label">Interest Rate</label>
                <div class="col-md-8 col-7">
                  <input type="text" class="form-control" placeholder="11.75" formControlName="InterestRate">
                  <div
                    *ngIf="oobaCalculatorFormControls.InterestRate.touched && oobaCalculatorFormControls.InterestRate.errors"
                    class="invalid-feedback">
                    <div *ngIf="oobaCalculatorFormControls.InterestRate.errors.required">Interest Rate is required</div>
                  </div>
                </div>
              </div>
              <div class="form-group row mb-3">
                <label for="interestRate" class="col-md-4 col-5 col-form-label">Term</label>
                <div class="col-md-8 col-7">
                  <select id="inputState" class="form-control form-select" formControlName="YearsToRepay">
                    <option value="20" selected>20 years</option>
                    <option value="30">30 years</option>
                  </select>
                  <div
                    *ngIf="oobaCalculatorFormControls.YearsToRepay.touched && oobaCalculatorFormControls.YearsToRepay.errors"
                    class="invalid-feedback">
                    <div *ngIf="oobaCalculatorFormControls.YearsToRepay.errors.required">Term is required</div>
                  </div>
                </div>
              </div>


              <div class="form-group mb-3 d-flex align-items-center">
                <button class="bank_button w-100 m-0 py-3 buttonfont d-md-block d-none"
                  id="btn_OobaCalculateHit_Products" name="btn_OobaCalculateHit_Products"
                  type="submit">Calculate</button>
                <!--mobile-->
                <button class="bank_button w-100 m-0 py-3 buttonfont d-md-none d-block"
                  id="btn_OobaCalculateHit_Products" name="btn_OobaCalculateHit_Products"
                  type="submit">Calculate</button>
              </div>
              <div class="form-group mb-2 d-md-flex d-none align-items-center">
                <button class="bank_button w-100 m-0 py-3 buttonfont btn-black"
                  (click)="generateOobaLeads(true,false,false)" id="btn_OobaCallbackJustme_Products"
                  name="btn_OobaCallbackJustme_Products" type="button">{{buttonText ? buttonText : 'Call Me'}}</button>
              </div>
            </div>
            <div
              class="col-md-5 col-12 px-md-3 px-0 d-flex flex-wrap align-items-stretch bg-orange bg-white-mobile rounded">
              <!--desktop caltulation-->
              <div class="d-md-flex d-none flex-wrap row mt-5 mt-md-0  ">
                <div class="d-flex flex-wrap align-items-center">

                  <div class="col-12  mt-auto">
                    <div class="w-100 d-md-block d-none mb-4">
                      <img src="../../assets/images/jm-white-logo.png" class="jmwlogo" />
                    </div>
                    <div class=" w-100  mb-4">
                      <label for="term" class="m-0 text-center d-block"><b>Estimated home loan amount</b></label>
                      <span class="d-block text-center estimateammount">R {{ estimatedLoanAmount |
                        number:'1.0-0'}}</span>
                    </div>
                  </div>
                  <div class="col-12  mb-auto">
                    <div class="w-100 ">
                      <label for="term" class="m-0 text-center d-block"><b>Estimated monthly repayment</b></label>
                      <span class="d-block text-center estimateammount">R {{ estimatedMonthlyRepayment | number:'1.0-0'
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!--mobile-->
              <div class="d-md-none d-block flex-wrap mt-4 mt-md-0 mb-4 bg-orange bg-white-mobile rounded "
                *ngIf="oobaShowDiv">
                <div class="d-flex flex-wrap align-items-center">

                  <div class="col-12  mt-auto">
                    <div class="w-100 d-md-block d-none mb-4">
                      <img src="../../assets/images/jm-white-logo.png" class="jmwlogo" />
                    </div>
                    <div class=" w-100  mb-4">
                      <label for="term" class="m-0 text-center d-block"><b>Estimated home loan amount</b></label>
                      <span class="d-block text-center estimateammount">R {{ estimatedLoanAmount |
                        number:'1.0-0'}}</span>
                    </div>
                  </div>
                  <div class="col-12  mb-auto">
                    <div class="w-100 ">
                      <label for="term" class="m-0 text-center d-block"><b>Estimated monthly repayment</b></label>
                      <span class="d-block text-center estimateammount">R {{ estimatedMonthlyRepayment | number:'1.0-0'
                        }}</span>
                    </div>
                  </div>
                </div>

              </div>
              <div class="form-group mb-2 d-md-none d-block align-items-center mt-0 w-100">
                <button class="bank_button w-100 m-0 py-3 buttonfont btn-black"
                  (click)="generateOobaLeads(true,false,false)" id="btn_OobaCallbackJustme_Products"
                  name="btn_OobaCallbackJustme_Products" type="button">{{buttonText ? buttonText : 'Call Me'}}</button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="tab-pane fade" id="jointApplication" role="tabpanel" aria-labelledby="jointApplication-tab">
        <form [formGroup]="oobaCombineCalculatorForm" id="oobaCombineCalculatorForm"
          (ngSubmit)="calculateCombineOobaAffordability()" novalidate>
          <div class="d-flex flex-wrap align-items-stretch">
            <div class="col-md-7 col-12 ps-md-0 ps-0 pe-md-3 pe-0">
              <div>
                <h2 class="familyincomecaption text-center">My Income</h2>
              </div>
              <!-- Applicant 1 - Gross Monthly Income -->
              <div class="form-group mb-2">
                <label for="GrossMonthlyIncomePartner1" class="m-0">Gross Income
                  <a class="collapsed arrow" role="button"
                    (click)="isGrossIncomeApp1Collapsed = !isGrossIncomeApp1Collapsed"
                    [attr.aria-expanded]="!isGrossIncomeApp1Collapsed" aria-controls="grossIncomeinfoApp1"
                    id="lnkgrossIncomeinfoApp1">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path
                          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
                          id="info" />
                      </defs>
                      <use fill-rule="nonzero" xlink:href="#info" />
                    </svg>
                  </a>
                </label>
                <div>
                </div>
                <div [ngbCollapse]="isGrossIncomeApp1Collapsed" class="collapse infobox" id="grossIncomeinfoApp1"
                  data-bs-parent="#accordion-info">
                  <div class="card card-body p-3 text-sm border-0 text-white ">
                    <a class="closeinfo" role="button" (click)="isGrossIncomeApp1Collapsed = true" aria-expanded="false"
                      aria-controls="grossIncomeinfoApp1" id="lnkgrossIncomeinfoApp1Close">
                      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                          <path id="cross"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </defs>
                        <use fill="#ffffff" fill-rule="nonzero" xlink:href="#cross" />
                      </svg>
                    </a>
                    Your gross monthly income is your total monthly earnings before tax and other deductions. It
                    includes your salary and any other income, such as rental earnings or a pension. If you’re applying
                    with a partner, please enter your combined income.
                  </div>
                </div>
                <input type="text" class="form-control" placeholder="R 22,000" appCurrencyMask
                  formControlName="GrossMonthlyIncomePartner1">
                <div
                  *ngIf="oobaCombineCalculatorFormControls.GrossMonthlyIncomePartner1.touched && oobaCombineCalculatorFormControls.GrossMonthlyIncomePartner1.errors"
                  class="invalid-feedback">
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.GrossMonthlyIncomePartner1.errors.required && validationErrorForJointTabPartner1GrossIncome === ''">
                    Gross Income is required</div>
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.GrossMonthlyIncomePartner1.errors.min  && validationErrorForJointTabPartner1GrossIncome === ''">
                    Gross income must be more than 0 to continue.</div>
                </div>
                <div *ngIf="validationErrorForJointTabPartner1GrossIncome !== ''" class="invalid-feedback">
                  <div>{{ validationErrorForJointTabPartner1GrossIncome }}</div>
                </div>
              </div>
              <!-- Applicant 1 - Net Monthly Income -->
              <div class="form-group mb-2">
                <label for="NetMonthlyIncomePartner1" class="m-0">Net Income
                  <a class="collapsed arrow" role="button"
                    (click)="isNetIncomeApp1Collapsed = !isNetIncomeApp1Collapsed"
                    [attr.aria-expanded]="!isNetIncomeApp1Collapsed" aria-controls="netIncomeinfoApp1"
                    id="lnkNetIncomeinfoApp1">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path
                          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
                          id="info" />
                      </defs>
                      <use fill-rule="nonzero" xlink:href="#info" />
                    </svg>
                  </a>
                </label>
                <div [ngbCollapse]="isNetIncomeApp1Collapsed" class="collapse infobox" id="netIncomeinfoApp1"
                  data-bs-parent="#accordion-info">
                  <div class="card card-body p-3 text-sm border-0 text-white ">
                    <a class="closeinfo" role="button" (click)="isNetIncomeApp1Collapsed = true" aria-expanded="false"
                      aria-controls="netIncomeinfoApp1" id="lnkNetIncomeinfoApp1Close">
                      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                          <path id="cross"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </defs>
                        <use fill="#ffffff" fill-rule="nonzero" xlink:href="#cross" />
                      </svg>
                    </a>
                    Your net monthly income is your earnings after tax and other salary deductions, such as medical aid
                    and retirement contributions.
                  </div>
                </div>
                <input type="text" class="form-control" placeholder="R 20,000" appCurrencyMask
                  formControlName="NetMonthlyIncomePartner1"
                  (input)="updateNetSurplusIncome(oobaCombineCalculatorForm, 'NetMonthlyIncomePartner1', 'NetSurplusIncomePartner1', 'TotalMonthlyExpensesPartner1')">
                <div
                  *ngIf="oobaCombineCalculatorFormControls.NetMonthlyIncomePartner1.touched && oobaCombineCalculatorFormControls.NetMonthlyIncomePartner1.errors"
                  class="invalid-feedback">
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.NetMonthlyIncomePartner1.errors.required && validationErrorForJointTabPartner1NetIncome === ''">
                    Net Income is required</div>
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.NetMonthlyIncomePartner1.errors.min && validationErrorForJointTabPartner1NetIncome === ''">
                    Net income must be more than 0 to continue.</div>
                </div>
                <div *ngIf="validationErrorForJointTabPartner1NetIncome !== ''" class="invalid-feedback">
                  <div>{{ validationErrorForJointTabPartner1NetIncome }}</div>
                </div>
              </div>
              <!-- Applicant 1 - Total Monthly Expenses -->
              <div class="form-group mb-2">
                <label for="netIncome" class="m-0">Total Monthly Expenses
                  <a class="collapsed arrow" role="button"
                    (click)="isMonthlyExpensesApp1Collapsed = !isMonthlyExpensesApp1Collapsed"
                    [attr.aria-expanded]="!isMonthlyExpensesApp1Collapsed" aria-controls="monthlyExpensesinfoApp1"
                    id="lnkMonthlyExpensesinfoApp1">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path
                          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
                          id="info" />
                      </defs>
                      <use fill-rule="nonzero" xlink:href="#info" />
                    </svg>
                  </a>
                </label>
                <div [ngbCollapse]="isMonthlyExpensesApp1Collapsed" class="collapse infobox"
                  id="monthlyExpensesinfoApp1" data-bs-parent="#accordion-info">
                  <div class="card card-body p-3 text-sm border-0 text-white ">
                    <a class="closeinfo" role="button" (click)="isMonthlyExpensesApp1Collapsed = true"
                      aria-expanded="false" aria-controls="monthlyExpensesinfoApp1"
                      id="lnkMonthlyExpensesinfoApp1Close">
                      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                          <path id="cross"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </defs>
                        <use fill="#ffffff" fill-rule="nonzero" xlink:href="#cross" />
                      </svg>
                    </a>
                    These include fixed expenses, such as rent and school fees, and variable expenses, such as utilities
                    and groceries.
                  </div>
                </div>
                <input type="text" class="form-control" placeholder="R 10,000" appCurrencyMask
                  formControlName="TotalMonthlyExpensesPartner1"
                  (input)="updateNetSurplusIncome(oobaCombineCalculatorForm, 'NetMonthlyIncomePartner1', 'NetSurplusIncomePartner1', 'TotalMonthlyExpensesPartner1')">
                <div
                  *ngIf="oobaCombineCalculatorFormControls.TotalMonthlyExpensesPartner1.touched && oobaCombineCalculatorFormControls.TotalMonthlyExpensesPartner1.errors"
                  class="invalid-feedback">
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.TotalMonthlyExpensesPartner1.errors.required && validationErrorForJointTabPartner1TotalExpenses === ''">
                    Total Monthly Expenses is required</div>
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.TotalMonthlyExpensesPartner1.errors.min && validationErrorForJointTabPartner1TotalExpenses === ''">
                    Expenses must be more than 0 to continue.</div>
                </div>
                <div *ngIf="validationErrorForJointTabPartner1TotalExpenses !== ''" class="invalid-feedback">
                  <div>{{ validationErrorForJointTabPartner1TotalExpenses }}</div>
                </div>
              </div>
              <!-- Applicant 1 - Net Surplus Income -->
              <div class="form-group mb-4">
                <label for="netsurplus" class="m-0">Net Surplus Income
                  <a class="collapsed arrow" role="button"
                    (click)="isNetSurplusApp1Collapsed = !isNetSurplusApp1Collapsed"
                    [attr.aria-expanded]="!isNetSurplusApp1Collapsed" aria-controls="netSurplusinfoApp1"
                    id="lnkNetSurplusinfoApp1">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path
                          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
                          id="info" />
                      </defs>
                      <use fill-rule="nonzero" xlink:href="#info" />
                    </svg>
                  </a>
                </label>
                <div [ngbCollapse]="isNetSurplusApp1Collapsed" class="collapse infobox" id="netSurplusinfoApp1"
                  data-bs-parent="#accordion-info">
                  <div class="card card-body p-3 text-sm border-0 text-white ">
                    <a class="closeinfo" role="button" (click)="isNetSurplusApp1Collapsed = true" aria-expanded="false"
                      aria-controls="netSurplusinfoApp1" id="lnkNetSurplusinfoApp1Close">
                      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                          <path id="cross"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </defs>
                        <use fill="#ffffff" fill-rule="nonzero" xlink:href="#cross" />
                      </svg>
                    </a>
                    This is the money you have left after you have deducted your monthly expenses from your net income.
                  </div>
                </div>
                <input type="text" class="form-control disabled" placeholder="R 10,000" appCurrencyMask
                  formControlName="NetSurplusIncomePartner1" readonly>
              </div>

              <div>
                <h2 class="familyincomecaption text-center">Partner's Income</h2>
              </div>
              <!-- Applicant 2 - Gross Monthly Income -->
              <div class="form-group mb-2">
                <label for="GrossMonthlyIncomePartner2" class="m-0">Gross Income
                  <a class="collapsed arrow" role="button"
                    (click)="isGrossIncomeApp2Collapsed = !isGrossIncomeApp2Collapsed"
                    [attr.aria-expanded]="!isGrossIncomeApp2Collapsed" aria-controls="grossIncomeinfoApp2"
                    id="lnkGrossIncomeinfoApp2">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path
                          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
                          id="info" />
                      </defs>
                      <use fill-rule="nonzero" xlink:href="#info" />
                    </svg>
                  </a>
                </label>
                <div>
                </div>
                <div [ngbCollapse]="isGrossIncomeApp2Collapsed" class="collapse infobox" id="grossIncomeinfoApp2"
                  data-bs-parent="#accordion-info">
                  <div class="card card-body p-3 text-sm border-0 text-white ">
                    <a class="closeinfo" role="button" (click)="isGrossIncomeApp2Collapsed = true" aria-expanded="false"
                      aria-controls="grossIncomeinfoApp2" id="lnkGrossIncomeinfoApp2Close">
                      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                          <path id="cross"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </defs>
                        <use fill="#ffffff" fill-rule="nonzero" xlink:href="#cross" />
                      </svg>
                    </a>
                    Your gross monthly income is your total monthly earnings before tax and other deductions. It
                    includes your salary and any other income, such as rental earnings or a pension. If you’re applying
                    with a partner, please enter your combined income.
                  </div>
                </div>
                <input type="text" class="form-control" placeholder="R 22,000" appCurrencyMask
                  formControlName="GrossMonthlyIncomePartner2">
                <div
                  *ngIf="oobaCombineCalculatorFormControls.GrossMonthlyIncomePartner2.touched && oobaCombineCalculatorFormControls.GrossMonthlyIncomePartner2.errors"
                  class="invalid-feedback">
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.GrossMonthlyIncomePartner2.errors.required && validationErrorForJointTabPartner2GrossIncome === ''">
                    Gross Income is required</div>
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.GrossMonthlyIncomePartner2.errors.min && validationErrorForJointTabPartner2GrossIncome === ''">
                    Gross income must be more than 0 to continue.</div>
                </div>
                <div *ngIf="validationErrorForJointTabPartner2GrossIncome !== ''" class="invalid-feedback">
                  <div>{{ validationErrorForJointTabPartner2GrossIncome }}</div>
                </div>
              </div>
              <!-- Applicant 2 - Net Monthly Income -->
              <div class="form-group mb-2">
                <label for="NetMonthlyIncomePartner2" class="m-0">Net Income
                  <a class="collapsed arrow" role="button"
                    (click)="isNetIncomeApp2Collapsed = !isNetIncomeApp2Collapsed"
                    [attr.aria-expanded]="!isNetIncomeApp2Collapsed" aria-controls="netIncomeinfoApp2"
                    id="lnkNetIncomeinfoApp2">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path
                          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
                          id="info" />
                      </defs>
                      <use fill-rule="nonzero" xlink:href="#info" />
                    </svg>
                  </a>
                </label>
                <div [ngbCollapse]="isNetIncomeApp2Collapsed" class="collapse infobox" id="netIncomeinfoApp2"
                  data-bs-parent="#accordion-info">
                  <div class="card card-body p-3 text-sm border-0 text-white ">
                    <a class="closeinfo" role="button" (click)="isNetIncomeApp2Collapsed = true" aria-expanded="false"
                      aria-controls="netIncomeinfoApp2" id="lnkNetIncomeinfoApp2Close">
                      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                          <path id="cross"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </defs>
                        <use fill="#ffffff" fill-rule="nonzero" xlink:href="#cross" />
                      </svg>
                    </a>
                    Your net monthly income is your earnings after tax and other salary deductions, such as medical aid
                    and retirement contributions.
                  </div>
                </div>
                <input type="text" class="form-control" placeholder="R 20,000" appCurrencyMask
                  formControlName="NetMonthlyIncomePartner2"
                  (input)="updateNetSurplusIncome(oobaCombineCalculatorForm, 'NetMonthlyIncomePartner2', 'NetSurplusIncomePartner2', 'TotalMonthlyExpensesPartner2')">
                <div
                  *ngIf="oobaCombineCalculatorFormControls.NetMonthlyIncomePartner2.touched && oobaCombineCalculatorFormControls.NetMonthlyIncomePartner2.errors"
                  class="invalid-feedback">
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.NetMonthlyIncomePartner2.errors.required && validationErrorForJointTabPartner2NetIncome === ''">
                    Net Income is required</div>
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.NetMonthlyIncomePartner2.errors.min  && validationErrorForJointTabPartner2NetIncome === ''">
                    Net income must be more than 0 to continue.
                  </div>
                </div>
                <div *ngIf="validationErrorForJointTabPartner2NetIncome !== ''" class="invalid-feedback">
                  <div>{{ validationErrorForJointTabPartner2NetIncome }}</div>
                </div>
              </div>
              <!-- Applicant 2 - Total Monthly Expenses -->
              <div class="form-group mb-2">
                <label for="netIncome" class="m-0">Total Monthly Expenses
                  <a class="collapsed arrow" role="button"
                    (click)="isMonthlyExpensesApp2Collapsed = !isMonthlyExpensesApp2Collapsed"
                    [attr.aria-expanded]="!isMonthlyExpensesApp2Collapsed" aria-controls="monthlyExpensesinfoApp2"
                    id="lnkMonthlyExpensesinfoApp2">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path
                          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
                          id="info" />
                      </defs>
                      <use fill-rule="nonzero" xlink:href="#info" />
                    </svg>
                  </a>
                </label>
                <div [ngbCollapse]="isMonthlyExpensesApp2Collapsed" class="collapse infobox"
                  id="monthlyExpensesinfoApp2" data-bs-parent="#accordion-info">

                  <div class="card card-body p-3 text-sm border-0 text-white ">
                    <a class="closeinfo" role="button" (click)="isMonthlyExpensesApp2Collapsed = true"
                      aria-expanded="false" aria-controls="monthlyExpensesinfoApp2"
                      id="lnkMonthlyExpensesinfoApp2Close">
                      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                          <path id="cross"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </defs>
                        <use fill="#ffffff" fill-rule="nonzero" xlink:href="#cross" />
                      </svg>
                    </a>
                    These include fixed expenses, such as rent and school fees, and variable expenses, such as utilities
                    and groceries.
                  </div>
                </div>
                <input type="text" class="form-control" placeholder="R 10,000" appCurrencyMask
                  formControlName="TotalMonthlyExpensesPartner2"
                  (input)="updateNetSurplusIncome(oobaCombineCalculatorForm, 'NetMonthlyIncomePartner2', 'NetSurplusIncomePartner2', 'TotalMonthlyExpensesPartner2')">
                <div
                  *ngIf="oobaCombineCalculatorFormControls.TotalMonthlyExpensesPartner2.touched && oobaCombineCalculatorFormControls.TotalMonthlyExpensesPartner2.errors"
                  class="invalid-feedback">
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.TotalMonthlyExpensesPartner2.errors.required && validationErrorForJointTabPartner2TotalExpenses ===''">
                    Total Monthly Expenses is required</div>
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.TotalMonthlyExpensesPartner2.errors.min && validationErrorForJointTabPartner2TotalExpenses ===''">
                    Expenses must be more than 0 to continue.
                  </div>
                </div>
                <div *ngIf="validationErrorForJointTabPartner2TotalExpenses !== ''" class="invalid-feedback">
                  <div>{{ validationErrorForJointTabPartner2TotalExpenses }}</div>
                </div>
              </div>
              <!-- Applicant 2 - Net Surplus Income -->
              <div class="form-group mb-4">
                <label for="netsurplus" class="m-0">Net Surplus Income
                  <a class="collapsed arrow" role="button"
                    (click)="isNetSurplusApp2Collapsed = !isNetSurplusApp2Collapsed"
                    [attr.aria-expanded]="!isNetSurplusApp2Collapsed" aria-controls="netSurplusinfoApp2"
                    id="lnkNetSurplusinfoApp2">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <path
                          d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
                          id="info" />
                      </defs>
                      <use fill-rule="nonzero" xlink:href="#info" />
                    </svg>
                  </a>
                </label>
                <div [ngbCollapse]="isNetSurplusApp2Collapsed" class="collapse infobox" id="netSurplusinfoApp2"
                  data-bs-parent="#accordion-info">
                  <div class="card card-body p-3 text-sm border-0 text-white ">
                    <a class="closeinfo" role="button" (click)="isNetSurplusApp2Collapsed = true" aria-expanded="false"
                      aria-controls="netSurplusinfoApp2" id="lnkNetSurplusinfoApp2Close">
                      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                          <path id="cross"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </defs>
                        <use fill="#ffffff" fill-rule="nonzero" xlink:href="#cross" />
                      </svg>
                    </a>
                    This is the money you have left after you have deducted your monthly expenses from your net income.
                  </div>
                </div>
                <input type="text" class="form-control disabled" placeholder="R 10,000" appCurrencyMask
                  formControlName="NetSurplusIncomePartner2" readonly>
              </div>

              <!-- Common Form Group for Interest Rate and Term -->
              <div class="form-group row mb-3">
                <label for="interestRate" class="col-md-4 col-5 col-form-label">Interest Rate</label>
                <div class="col-md-8 col-7">
                  <input type="text" class="form-control" placeholder="11.75" formControlName="InterestRate">
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.InterestRate.touched && oobaCombineCalculatorFormControls.InterestRate.errors"
                    class="invalid-feedback">
                    <div *ngIf="oobaCombineCalculatorFormControls.InterestRate.errors.required">Interest Rate is
                      required</div>
                  </div>
                </div>
              </div>
              <div class="form-group row mb-3">
                <label for="interestRate" class="col-md-4 col-5 col-form-label">Term</label>
                <div class="col-md-8 col-7">
                  <select id="inputState" class="form-control form-select" formControlName="YearsToRepay">
                    <option value="20" selected>20 years</option>
                    <option value="30">30 years</option>
                  </select>
                  <div
                    *ngIf="oobaCombineCalculatorFormControls.YearsToRepay.touched && oobaCombineCalculatorFormControls.YearsToRepay.errors"
                    class="invalid-feedback">
                    <div *ngIf="oobaCombineCalculatorFormControls.YearsToRepay.errors.required">Term is required</div>
                  </div>
                </div>
              </div>

              <!-- Common Calculate Button -->
              <div class="form-group mb-3 d-flex align-items-center">
                <button class="bank_button w-100 m-0 py-3 buttonfont d-md-block d-none" type="submit">Calculate</button>
                <!--mobile-->
                <button class="bank_button w-100 m-0 py-3 buttonfont d-md-none d-block"
                  id="btn_OobaCalculateHit_Products" name="btn_OobaCalculateHit_Products"
                  type="submit">Calculate</button>
              </div>
              <div class="form-group mb-2 d-md-flex d-none align-items-center">
                <button class="bank_button w-100 m-0 py-3 buttonfont btn-black"
                  (click)="generateOobaLeads(false,false,true)" id="btn_OobaCallbackJustme_Products"
                  name="btn_OobaCallbackJustme_Products" type="button">{{buttonText ? buttonText : 'Call Me'}}</button>
              </div>
            </div>

            <!-- Estimated Amount Display -->
            <div class="col-md-5 col-12 px-0 d-flex flex-wrap align-items-stretch bg-orange bg-white-mobile rounded">
              <!--desktop caltulation-->
              <div class="d-md-flex d-none flex-wrap row mt-5 mt-md-0 ">
                <div class="d-flex flex-wrap align-items-center">
                  <!-- Estimated Loan Amount -->
                  <div class="col-12 mt-auto">
                    <div class="w-100 d-md-block d-none mb-4">
                      <img src="../../assets/images/jm-white-logo.png" class="jmwlogo" />
                    </div>
                    <div class="w-100 mb-4">
                      <label for="term" class="m-0 text-center d-block"><b>Estimated home loan amount</b></label>
                      <span class="d-block text-center estimateammount">R {{ estimatedLoanAmountCombine |
                        number:'1.0-0'}}</span>
                    </div>
                  </div>
                  <!-- Estimated Monthly Repayment -->
                  <div class="col-12 mb-auto">
                    <div class="w-100">
                      <label for="term" class="m-0 text-center d-block"><b>Estimated monthly repayment</b></label>
                      <span class="d-block text-center estimateammount">R {{ estimatedMonthlyRepaymentCombine |
                        number:'1.0-0' }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!--mobile-->
              <div class="d-md-none d-block flex-wrap mt-4 mt-md-0 bg-white-mobile mb-4"
                *ngIf="oobaJointApplicationShowDiv">
                <div class="d-flex flex-wrap align-items-center">

                  <!-- Estimated Loan Amount -->
                  <div class="col-12 mt-auto">
                    <div class="w-100 d-md-block d-none mb-4">
                      <img src="../../assets/images/jm-white-logo.png" class="jmwlogo" />
                    </div>
                    <div class="w-100 mb-4">
                      <label for="term" class="m-0 text-center d-block"><b>Estimated home loan amount</b></label>
                      <span class="d-block text-center estimateammount">R {{ estimatedLoanAmountCombine |
                        number:'1.0-0'}}</span>
                    </div>
                  </div>
                  <!-- Estimated Monthly Repayment -->
                  <div class="col-12 mb-auto">
                    <div class="w-100">
                      <label for="term" class="m-0 text-center d-block"><b>Estimated monthly repayment</b></label>
                      <span class="d-block text-center estimateammount">R {{ estimatedMonthlyRepaymentCombine |
                        number:'1.0-0' }}</span>
                    </div>
                  </div>
                </div>

              </div>
              <div class="form-group mb-2 d-md-none d-block mt-0 align-items-center w-100">
                <button class="bank_button w-100 m-0 py-3 buttonfont btn-black"
                  (click)="generateOobaLeads(false,false,true)" id="btn_OobaCallbackJustme_Products"
                  name="btn_OobaCallbackJustme_Products" type="button">{{buttonText ? buttonText : 'Call Me'}}</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-5">
      <a href="javascript:void(0)" class="btn-link-back"
        (click)="modal.dismiss('Cross click'); toggleOobaCalculationHide(); toogleOobaJointCalculationHide()">
        <i class="pe-2">
          <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976314 8.31658 0.292893 8.70711L6.65686 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928933C7.68054 0.538409 7.04738 0.538409 6.65685 0.928933L0.292892 7.29289ZM19 7L1 7L1 9L19 9L19 7Z"
              fill="#4AAEAC" />
          </svg>
        </i> Back
      </a>
    </div>
  </div>
</ng-template>

<ng-template #oobastaysavvySuccessModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Savvy move!</h4>
    <button type="button" id="callbackSuccessModelClosed" class="close" data-dismiss="modal"
      name="callbackSuccessModelClosed" isCloseButton="true" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span id="callbackSuccessModelClosed" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" class="alert alert-success" role="alert">
    <p>One of the experts at ooba Home Loans will contact you within 24 to 48 hours.</p>
  </div>
</ng-template>



<ng-template #motorVehicleCalculatorModel let-modal>
  <div class="modal-header darkblue">
    <h4 class="modal-title text-white d-flex align-items-center"><i class="pe-md-3 pe-2"><img
          src="../../assets/images/caricon.png" alt="" width="50px" /></i> Vehicle Finance Calculator</h4>
    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close"
      name="motorVehicleCalculatorModelClosed" id="motorVehicleCalculatorModelClosed" isCloseButton="true"
      (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="close-white">&times;</span>
    </button>
  </div>
  <div class="modal-body oobacalculator" id="accordion-info">
    <app-motor-vehicle-finance-calculator>

    </app-motor-vehicle-finance-calculator>
    <div class="d-flex justify-content-center mt-5">
      <a href="javascript:void(0)" class="btn-link-back" id="lnkMVF" (click)="modal.dismiss('Cross click')">
        <i class="pr-2">
          <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976314 8.31658 0.292893 8.70711L6.65686 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928933C7.68054 0.538409 7.04738 0.538409 6.65685 0.928933L0.292892 7.29289ZM19 7L1 7L1 9L19 9L19 7Z"
              fill="#4AAEAC" />
          </svg>
        </i> Back
      </a>
    </div>
  </div>
</ng-template>



<!-- Fixed bottom-right banner -->
<div class="bottom-banner" [class.visible]="isSplNudgeVisible">
  <p><img class="nudge-img" src="../../assets/images/sanlam_logo.svg" alt="logo" />
    <strong class="ms-2"> Get a cash boost with Sanlam</strong>
  </p>
  <div class="progress-bar">
    <div class="progress"></div>
  </div>
  <p>You have a high chance of qualifying for a <strong>Sanlam personal loan.</strong> Reach your money goals – your
    growth journey starts
    here!</p>
  <div class="banner-buttons">
    <button class="decline fw-bolder" id="btn_auxiliaryButton_SPL_digital_nudge_no_nudgeOffersPage"
      name="btn_auxiliaryButton_SPL_digital_nudge_no_nudgeOffersPage" (click)="DismissNudge()">No,
      thanks</button>
    <button class="accept fw-bolder" id="btn_leadGen_SPL_digital_nudgeOffersPage"
      name="btn_leadGen_SPL_digital_nudgeOffersPage" (click)="transferLead()">Get offer</button>
  </div>
</div>

<div class="bottom-banner" [class.visible]="isDcNudgeVisible">
  <p><img class="nudge-img" src="../../assets/images/db_logo_image.png" alt="logo" />
    <strong class="ms-2">Free up cash with DebtBusters</strong>
  </p>
  <div class="progress-bar">
    <div class="progress"></div>
  </div>
  <p>You have a high chance of qualifying for <strong>debt counselling</strong>. Boost your confidence, lower your
    instalments, and get peace of mind. Growth feels good – and so does saving money!</p>
  <div class="banner-buttons">
    <button class="decline fw-bolder " id="btn_auxiliaryButton_consolidateLoan_callBack_nudge_no_nudgeOffersPage"
      name="btn_auxiliaryButton_consolidateLoan_callBack_nudge_no_nudgeOffersPage" (click)="DismissNudge()">No,
      thanks</button>
    <button class="accept fw-bolder" id="btn_leadGen_consolidateLoan_callBack_nudgeOffersPage"
      name="btn_leadGen_consolidateLoan_callBack_nudgeOffersPage" (click)="DCEngage()">Call me</button>
  </div>
</div>
<ng-template #dcCallbackStatusModel let-modal>
  <div class="modal-header">
    <h4 *ngIf="callbackErrorMsg==''" class="modal-title fw-bold">Free call-back incoming...</h4>
    <h4 *ngIf="callbackErrorMsg!=''" class="modal-title fw-bold">Free callback request</h4>
    <button type="button" class="close" id="btn_auxiliaryButton_consolidateLoan_callBackRequested_popUp_close"
      name="btn_auxiliaryButton_consolidateLoan_callBackRequested_popUp_close" isCloseButton="true" data-dismiss="modal"
      aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span id="btn_auxiliaryButton_consolidateLoan_callBackRequested_popUp_close" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="callbackErrorMsg ==''" class="modal-body" class="success-box">


    <img src="../../assets/images/dblogonew.png" alt="DebtBusters Logo" width="72px" />
    <p class="mt-2 mb-0">Stand by, a DebtBusters expert will call you soon.</p>
  </div>
  <div *ngIf="callbackErrorMsg!=''" class="modal-body">
    <div class="alert alert-danger" role="alert">
      {{callbackErrorMsg}}
    </div>
  </div>
  <div class="modal-footer dc-success-footer" *ngIf="callbackErrorMsg==''">
    <button type="button" class="dc-popup-primary-success-btn"
      id="btn_auxiliaryButton_consolidateLoan_callBackRequested_popUp_close2"
      name="btn_auxiliaryButton_consolidateLoan_callBackRequested_popUp_close2"
      (click)="modal.dismiss('Cross click')">OK, thanks!</button>
  </div>
</ng-template>
  
<!-- <app-guidemark-offcanvas [tile]="selectedTile"
  [page]="selectedPage"
  [creditPaymentsAmount]="creditPaymentsAmount"
  [isDcNudgeVisible]="isDcNudgeVisible"
  (nudgeHandled)="isDcNudgeVisible = false;">
  </app-guidemark-offcanvas> -->